import React, { useState, useEffect } from 'react';
import { getFicha, updateFicha } from '../../api/api';
import './Ficha.css';
import Button from '../common/Button';
import BreastDiagram from './BreastDiagram';

// Dropdown Menu Component
const DropdownMenu = ({ label, items, activeTab, setActiveTab, isHighlighted = false }) => {
    const [isOpen, setIsOpen] = useState(false);
    const isActive = items.some(item => item.id === activeTab);

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    return (
        <div
            className="ficha-dropdown-menu"
            onMouseEnter={() => setIsOpen(true)}
            onMouseLeave={() => setIsOpen(false)}
        >
            <button
                className={`ficha-dropdown-trigger ${isActive ? 'active' : ''} ${isHighlighted ? 'highlighted' : ''}`}
                onClick={toggleDropdown}
            >
                {label} ▼
            </button>
            {isOpen && (
                <div className="ficha-dropdown-content">
                    {items.map(item => (
                        <button
                            key={item.id}
                            className={activeTab === item.id ? 'active' : ''}
                            onClick={() => {
                                setActiveTab(item.id);
                                setIsOpen(false);
                            }}
                        >
                            {item.label}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};

const DemograficosSection = ({ data, onChange, patientPhoto }) => {
    const calcularIMC = () => {
        if (data?.peso && data?.talla) {
            const imc = data.peso / (data.talla ** 2);
            return imc.toFixed(1);
        }
        return 'N/A';
    };

    // Generic female profile placeholder SVG
    const GENERIC_PHOTO = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23e482ad' width='100px' height='100px'%3E%3Cpath d='M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z'/%3E%3C/svg%3E";

    return (
        <div className="ficha-section">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                <h3>Datos Demográficos</h3>
                <div className="patient-photo-container" style={{
                    width: '100px',
                    height: '100px',
                    borderRadius: '50%',
                    overflow: 'hidden',
                    border: '3px solid #e482ad',
                    backgroundColor: '#fff0f6',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}>
                    <img
                        src={patientPhoto || GENERIC_PHOTO}
                        alt="Paciente"
                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                        onError={(e) => { e.target.onerror = null; e.target.src = GENERIC_PHOTO; }}
                    />
                </div>
            </div>
            <div className="form-grid">
                <div className="form-group">
                    <label>Edad</label>
                    <input type="text" value={data?.edad || ''} onChange={e => onChange('edad', e.target.value)} />
                </div>
                <div className="form-group">
                    <label>Fecha de Nacimiento</label>
                    <input type="date" value={data?.fecha_nacimiento?.split('T')[0] || ''} onChange={e => onChange('fecha_nacimiento', e.target.value)} />
                </div>
                <div className="form-group">
                    <label>Sexo</label>
                    <select value={data?.sexo || ''} onChange={e => onChange('sexo', e.target.value)}>
                        <option value="">Seleccionar</option>
                        <option value="F">Femenino</option>
                        <option value="M">Masculino</option>
                    </select>
                </div>
                <div className="form-group">
                    <label>Teléfono Contacto</label>
                    <input type="text" value={data?.telefono_contacto || ''} onChange={e => onChange('telefono_contacto', e.target.value)} />
                </div>
                <div className="form-group">
                    <label>Peso (kg)</label>
                    <input type="number" step="0.1" value={data?.peso || ''} onChange={e => onChange('peso', parseFloat(e.target.value))} />
                </div>
                <div className="form-group">
                    <label>Talla (m)</label>
                    <input type="number" step="0.01" value={data?.talla || ''} onChange={e => onChange('talla', parseFloat(e.target.value))} />
                </div>
                <div className="form-group">
                    <label>IMC (calculado)</label>
                    <input type="text" value={calcularIMC()} readOnly style={{ backgroundColor: '#f0f0f0' }} />
                </div>
                <div className="form-group">
                    <label>Estado Vital</label>
                    <select value={data?.estado_vital || ''} onChange={e => onChange('estado_vital', e.target.value)}>
                        <option value="">Seleccionar</option>
                        <option value="Vivo">Vivo</option>
                        <option value="Finado">Finado</option>
                    </select>
                </div>
                <div className="form-group">
                    <label>Estatus</label>
                    <select value={data?.estatus || ''} onChange={e => onChange('estatus', e.target.value)}>
                        <option value="">Seleccionar</option>
                        <option value="En proceso diagnóstico">En proceso diagnóstico</option>
                        <option value="En tratamiento">En tratamiento</option>
                        <option value="En seguimiento">En seguimiento</option>
                        <option value="Alta">Alta</option>
                    </select>
                </div>
                <div className="form-group" style={{ gridColumn: 'span 2' }}>
                    <label>Motivo de Consulta</label>
                    <textarea value={data?.motivo_consulta || ''} onChange={e => onChange('motivo_consulta', e.target.value)} />
                </div>
                <div className="form-group">
                    <label>Fecha Motivo Consulta</label>
                    <input type="date" value={data?.fecha_motivo_consulta?.split('T')[0] || ''} onChange={e => onChange('fecha_motivo_consulta', e.target.value)} />
                </div>
                <div className="form-group">
                    <label>Síntoma Inicial</label>
                    <input type="text" value={data?.sintoma_inicial || ''} onChange={e => onChange('sintoma_inicial', e.target.value)} />
                </div>
                <div className="form-group">
                    <label>Fecha Síntoma Inicial</label>
                    <input type="date" value={data?.fecha_sintoma_inicial?.split('T')[0] || ''} onChange={e => onChange('fecha_sintoma_inicial', e.target.value)} />
                </div>
                <div className="form-group">
                    <label>Tamizaje</label>
                    <select value={data?.tamizaje || 'NO'} onChange={e => onChange('tamizaje', e.target.value)}>
                        <option value="NO">NO</option>
                        <option value="SÍ">SÍ</option>
                    </select>
                </div>
                <div className="form-group">
                    <label>Fecha Tamizaje</label>
                    <input type="date" value={data?.fecha_tamizaje?.split('T')[0] || ''} onChange={e => onChange('fecha_tamizaje', e.target.value)} />
                </div>
                <div className="form-group checkbox-group">
                    <label className="checkbox-label" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <input
                            type="checkbox"
                            checked={data?.mastografia_diagnostica || false}
                            onChange={e => onChange('mastografia_diagnostica', e.target.checked)}
                            style={{ width: '20px', height: '20px' }}
                        />
                        Mastografía Diagnóstica
                    </label>
                </div>
                <div className="form-group">
                    <label>Fecha Mastografía</label>
                    <input type="date" value={data?.fecha_mastografia?.split('T')[0] || ''} onChange={e => onChange('fecha_mastografia', e.target.value)} />
                </div>
                <div className="form-group">
                    <label>Método Diagnóstico Inicial</label>
                    <input type="text" value={data?.metodo_diagnostico_inicial || ''} onChange={e => onChange('metodo_diagnostico_inicial', e.target.value)} />
                </div>
                <div className="form-group checkbox-group">
                    <label className="checkbox-label" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <input
                            type="checkbox"
                            checked={data?.ante_familiares_cancer_mama || false}
                            onChange={e => onChange('ante_familiares_cancer_mama', e.target.checked)}
                            style={{ width: '20px', height: '20px' }}
                        />
                        Antecedentes Familiares de Cáncer de Mama
                    </label>
                </div>
                <div className="form-group">
                    <label>Unidad de Referencia</label>
                    <input type="text" value={data?.unidad_referencia || ''} onChange={e => onChange('unidad_referencia', e.target.value)} />
                </div>
                <div className="form-group">
                    <label>Fecha de Referencia</label>
                    <input type="date" value={data?.fecha_referencia?.split('T')[0] || ''} onChange={e => onChange('fecha_referencia', e.target.value)} />
                </div>
                <div className="form-group">
                    <label>Fecha Ingreso Hospital</label>
                    <input type="date" value={data?.fecha_ingreso_hospital?.split('T')[0] || ''} onChange={e => onChange('fecha_ingreso_hospital', e.target.value)} />
                </div>
                <div className="form-group" style={{ gridColumn: 'span 2' }}>
                    <label>Tratamiento Previo Fuera de Institución</label>
                    <textarea value={data?.tratamiento_fuera_issste || ''} onChange={e => onChange('tratamiento_fuera_issste', e.target.value)} />
                </div>
                <div className="form-group" style={{ gridColumn: 'span 2' }}>
                    <label>Comorbilidades</label>
                    <textarea value={data?.comorbilidades || ''} onChange={e => onChange('comorbilidades', e.target.value)} />
                </div>
                <div className="form-group" style={{ gridColumn: 'span 2' }}>
                    <label>Observaciones</label>
                    <textarea value={data?.observaciones || ''} onChange={e => onChange('observaciones', e.target.value)} />
                </div>
            </div>

            <h4 style={{ marginTop: '20px' }}>Factores de Riesgo</h4>
            <div className="form-grid">
                <div className="form-group checkbox-group">
                    <label className="checkbox-label">
                        <input type="checkbox" checked={(data?.factores_riesgo || []).includes('Obesidad')} onChange={e => {
                            const current = data?.factores_riesgo || [];
                            onChange('factores_riesgo', e.target.checked ? [...current, 'Obesidad'] : current.filter(f => f !== 'Obesidad'));
                        }} />
                        Obesidad
                    </label>
                </div>
                <div className="form-group checkbox-group">
                    <label className="checkbox-label">
                        <input type="checkbox" checked={(data?.factores_riesgo || []).includes('Antecedente familiar')} onChange={e => {
                            const current = data?.factores_riesgo || [];
                            onChange('factores_riesgo', e.target.checked ? [...current, 'Antecedente familiar'] : current.filter(f => f !== 'Antecedente familiar'));
                        }} />
                        Antecedente familiar
                    </label>
                </div>
                <div className="form-group checkbox-group">
                    <label className="checkbox-label">
                        <input type="checkbox" checked={(data?.factores_riesgo || []).includes('Nuliparidad')} onChange={e => {
                            const current = data?.factores_riesgo || [];
                            onChange('factores_riesgo', e.target.checked ? [...current, 'Nuliparidad'] : current.filter(f => f !== 'Nuliparidad'));
                        }} />
                        Nuliparidad
                    </label>
                </div>
                <div className="form-group checkbox-group">
                    <label className="checkbox-label">
                        <input type="checkbox" checked={(data?.factores_riesgo || []).includes('Menarca temprana')} onChange={e => {
                            const current = data?.factores_riesgo || [];
                            onChange('factores_riesgo', e.target.checked ? [...current, 'Menarca temprana'] : current.filter(f => f !== 'Menarca temprana'));
                        }} />
                        Menarca temprana
                    </label>
                </div>
            </div>
        </div>
    );
};


const HallazgosSection = ({ data, onAdd, onUpdate }) => (
    <div className="ficha-section">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
            <h3>Hallazgos Clínicos e Imagen (Historial)</h3>
            <button className="add-btn" onClick={() => onAdd('hallazgos')}>+ Registrar Nuevo Hallazgo</button>
        </div>

        <div className="section-list">
            {(data && data.length > 0) ? data.map((item, index) => (
                <div key={index} className="list-item-card" style={{ marginBottom: '30px', borderLeft: '4px solid #3b82f6' }}>
                    <div className="form-grid">
                        <div className="form-group">
                            <label>Fecha del Hallazgo</label>
                            <input type="date" value={item.fecha?.split('T')[0] || ''} onChange={e => onUpdate('hallazgos', index, 'fecha', e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>Tipo de Estudio</label>
                            <select value={item.tipo_estudio || ''} onChange={e => onUpdate('hallazgos', index, 'tipo_estudio', e.target.value)}>
                                <option value="">Seleccionar</option>
                                <option value="Mastografía de cribado">Mastografía de cribado</option>
                                <option value="Mastografía diagnóstica">Mastografía diagnóstica</option>
                                <option value="Ultrasonido">Ultrasonido</option>
                                <option value="Resonancia Magnética">Resonancia Magnética</option>
                            </select>
                        </div>
                        <div className="form-group">
                            <label>BIRADS</label>
                            <select value={item.birads || ''} onChange={e => onUpdate('hallazgos', index, 'birads', e.target.value)}>
                                <option value="">Seleccionar</option>
                                <option value="0">0 - Incompleto</option>
                                <option value="1">1 - Negativo</option>
                                <option value="2">2 - Benigno</option>
                                <option value="3">3 - Probablemente benigno</option>
                                <option value="4">4 - Sospechoso</option>
                                <option value="5">5 - Altamente sospechoso</option>
                                <option value="6">6 - Malignidad comprobada</option>
                            </select>
                        </div>
                        <div className="form-group">
                            <label>Densidad Mamaria</label>
                            <select value={item.densidad_mamaria || ''} onChange={e => onUpdate('hallazgos', index, 'densidad_mamaria', e.target.value)}>
                                <option value="">Seleccionar</option>
                                <option value="ACR A">ACR A - Casi completamente grasa</option>
                                <option value="ACR B">ACR B - Densidad fibroglandular dispersa</option>
                                <option value="ACR C">ACR C - Heterogéneamente densa</option>
                                <option value="ACR D">ACR D - Extremadamente densa</option>
                            </select>
                        </div>
                        <div className="form-group">
                            <label>Conducta Recomendada</label>
                            <input type="text" value={item.conducta || ''} onChange={e => onUpdate('hallazgos', index, 'conducta', e.target.value)} />
                        </div>
                        <div className="form-group" style={{ gridColumn: 'span 2' }}>
                            <label>Descripción del Hallazgo</label>
                            <textarea value={item.descripcion_hallazgo || ''} onChange={e => onUpdate('hallazgos', index, 'descripcion_hallazgo', e.target.value)} />
                        </div>

                        <h4 style={{ gridColumn: 'span 2', marginTop: '15px' }}>Localización</h4>
                        <div style={{ gridColumn: 'span 2', display: 'flex', gap: '20px', alignItems: 'flex-start', flexWrap: 'wrap' }}>
                            <div style={{ flex: '1', minWidth: '300px' }}>
                                <div className="form-grid" style={{ gridTemplateColumns: '1fr 1fr' }}>
                                    <div className="form-group">
                                        <label>Mama</label>
                                        <select value={item.mama || ''} onChange={e => onUpdate('hallazgos', index, 'mama', e.target.value)}>
                                            <option value="">Seleccionar</option>
                                            <option value="Derecha">Derecha</option>
                                            <option value="Izquierda">Izquierda</option>
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <label>Radio (Reloj)</label>
                                        <select value={item.radio || ''} onChange={e => onUpdate('hallazgos', index, 'radio', e.target.value)}>
                                            <option value="">N/A</option>
                                            {[...Array(12).keys()].map(n => (
                                                <option key={n+1} value={String(n+1)}>{n+1}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <label>Cuadrante</label>
                                        <select value={item.cuadrante || ''} onChange={e => onUpdate('hallazgos', index, 'cuadrante', e.target.value)}>
                                            <option value="">Seleccionar</option>
                                            <option value="Superior externo">Superior externo (CSE)</option>
                                            <option value="Superior interno">Superior interno (CSI)</option>
                                            <option value="Inferior externo">Inferior externo (CIE)</option>
                                            <option value="Inferior interno">Inferior interno (CII)</option>
                                            <option value="Zona retroareolar">Zona retroareolar (ZRA)</option>
                                            <option value="Axila">Axila (AX)</option>
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <label>Línea Intercuadrante</label>
                                        <select value={item.linea_intercuadrante || ''} onChange={e => onUpdate('hallazgos', index, 'linea_intercuadrante', e.target.value)}>
                                            <option value="">N/A</option>
                                            <option value="Superior">Superior</option>
                                            <option value="Inferior">Inferior</option>
                                            <option value="Externo">Externo</option>
                                            <option value="Interno">Interno</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            
                            <div style={{ 
                                background: '#f8fafc', 
                                padding: '15px', 
                                borderRadius: '12px', 
                                border: '1px solid #e2e8f0',
                                display: 'flex',
                                justifyContent: 'center'
                            }}>
                                <BreastDiagram 
                                    value={{ 
                                        mama: item.mama, 
                                        radio: item.radio, 
                                        cuadrante: item.cuadrante,
                                        linea_intercuadrante: item.linea_intercuadrante 
                                    }} 
                                    onChange={(val) => {
                                        // Update properties individually
                                        Object.keys(val).forEach(key => {
                                            onUpdate('hallazgos', index, key, val[key]);
                                        });
                                    }}
                                />
                            </div>
                        </div>

                        <h4 style={{ gridColumn: 'span 2', marginTop: '15px' }}>Características del Nódulo</h4>
                        <div className="form-group">
                            <label>Forma del Nódulo</label>
                            <select value={item.nodulo_forma || ''} onChange={e => onUpdate('hallazgos', index, 'nodulo_forma', e.target.value)}>
                                <option value="">Seleccionar</option>
                                <option value="Ovalada">Ovalada</option>
                                <option value="Redondeada">Redondeada</option>
                                <option value="Irregular">Irregular</option>
                            </select>
                        </div>
                        <div className="form-group">
                            <label>Margen del Nódulo</label>
                            <select value={item.nodulo_margen || ''} onChange={e => onUpdate('hallazgos', index, 'nodulo_margen', e.target.value)}>
                                <option value="">Seleccionar</option>
                                <option value="Circunscrito">Circunscrito</option>
                                <option value="Microlobulado">Microlobulado</option>
                                <option value="Oscurecido">Oscurecido</option>
                                <option value="Indistinto">Indistinto</option>
                                <option value="Espiculado">Espiculado</option>
                            </select>
                        </div>
                        <div className="form-group">
                            <label>Densidad del Nódulo</label>
                            <select value={item.nodulo_densidad || ''} onChange={e => onUpdate('hallazgos', index, 'nodulo_densidad', e.target.value)}>
                                <option value="">Seleccionar</option>
                                <option value="Alta">Alta</option>
                                <option value="Igual">Igual</option>
                                <option value="Baja">Baja</option>
                                <option value="Grasa">Grasa</option>
                            </select>
                        </div>

                        <h4 style={{ gridColumn: 'span 2', marginTop: '15px' }}>Calcificaciones</h4>
                        <div className="form-group">
                            <label>Tipo de Calcificaciones</label>
                            <input type="text" value={item.calcificaciones_tipo || ''} onChange={e => onUpdate('hallazgos', index, 'calcificaciones_tipo', e.target.value)} placeholder="Ej: Pleomórficas finas" />
                        </div>
                        <div className="form-group">
                            <label>Distribución</label>
                            <input type="text" value={item.calcificaciones_distribucion || ''} onChange={e => onUpdate('hallazgos', index, 'calcificaciones_distribucion', e.target.value)} placeholder="Ej: Agrupadas, Segmentarias" />
                        </div>

                        <h4 style={{ gridColumn: 'span 2', marginTop: '15px' }}>Otros Hallazgos</h4>
                        <div className="form-group">
                            <label>Distorsión de Arquitectura</label>
                            <input type="text" value={item.distorcion_arquitectura || ''} onChange={e => onUpdate('hallazgos', index, 'distorcion_arquitectura', e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>Asimetrías</label>
                            <input type="text" value={item.asimetrias || ''} onChange={e => onUpdate('hallazgos', index, 'asimetrias', e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>Ganglio Linfático</label>
                            <input type="text" value={item.ganglio_linfatico || ''} onChange={e => onUpdate('hallazgos', index, 'ganglio_linfatico', e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>Lesión Cutánea</label>
                            <input type="text" value={item.lesion_cutanea || ''} onChange={e => onUpdate('hallazgos', index, 'lesion_cutanea', e.target.value)} />
                        </div>
                        <div className="form-group" style={{ gridColumn: 'span 2' }}>
                            <label>Hallazgos Asociados</label>
                            <textarea value={item.hallazgos_asociados || ''} onChange={e => onUpdate('hallazgos', index, 'hallazgos_asociados', e.target.value)} />
                        </div>
                    </div>
                </div>
            )) : <p>No hay hallazgos registrados. Use el botón superior para agregar uno.</p>}
        </div>
    </div>
);

const RiesgosSection = ({ data, onAdd, onUpdate }) => (
    <div className="ficha-section">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
            <h3>Evaluación de Riesgos (Historial)</h3>
            <button className="add-btn" onClick={() => onAdd('riesgos')}>+ Nueva Evaluación</button>
        </div>

        <div className="section-list">
            {(data && data.length > 0) ? data.map((item, index) => (
                <div key={index} className="list-item-card" style={{ marginBottom: '30px', borderLeft: '4px solid #ef4444' }}>
                    <div className="form-grid">
                        <div className="form-group">
                            <label>Fecha de Evaluación</label>
                            <input type="date" value={item.fecha?.split('T')[0] || ''} onChange={e => onUpdate('riesgos', index, 'fecha', e.target.value)} />
                        </div>
                        <div className="form-group checkbox-group">
                            <label className="checkbox-label" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <input
                                    type="checkbox"
                                    checked={item.paciente_debuto_etapa4 || false}
                                    onChange={e => onUpdate('riesgos', index, 'paciente_debuto_etapa4', e.target.checked)}
                                    style={{ width: '20px', height: '20px' }}
                                />
                                ¿Paciente debutó en Etapa IV?
                            </label>
                        </div>
                        <div className="form-group">
                            <label>Riesgo Identificado</label>
                            <select value={item.riesgo_identificado || ''} onChange={e => onUpdate('riesgos', index, 'riesgo_identificado', e.target.value)}>
                                <option value="">Seleccionar</option>
                                <option value="Bajo">Bajo</option>
                                <option value="Intermedio">Intermedio</option>
                                <option value="Alto">Alto</option>
                            </select>
                        </div>
                        <div className="form-group" style={{ gridColumn: 'span 2' }}>
                            <label>Riesgos Clínicos</label>
                            <textarea value={item.clinicos || ''} onChange={e => onUpdate('riesgos', index, 'clinicos', e.target.value)} placeholder="Ej: Menarca temprana, nuliparidad" />
                        </div>
                        <div className="form-group">
                            <label>Extensión en el Momento</label>
                            <input type="text" value={item.extension_momento || ''} onChange={e => onUpdate('riesgos', index, 'extension_momento', e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>Resecabilidad</label>
                            <select value={item.resecabilidad || ''} onChange={e => onUpdate('riesgos', index, 'resecabilidad', e.target.value)}>
                                <option value="">Seleccionar</option>
                                <option value="Resecable">Resecable</option>
                                <option value="Limitada">Limitada</option>
                                <option value="Irresecable">Irresecable</option>
                            </select>
                        </div>
                        <div className="form-group">
                            <label>Riesgo de Recurrencia</label>
                            <input type="text" value={item.recurrencia || ''} onChange={e => onUpdate('riesgos', index, 'recurrencia', e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>Respuesta a Neoadyuvancia</label>
                            <select value={item.respuesta_neoadyuvancia || ''} onChange={e => onUpdate('riesgos', index, 'respuesta_neoadyuvancia', e.target.value)}>
                                <option value="">Seleccionar</option>
                                <option value="Respuesta completa">Respuesta completa</option>
                                <option value="Respuesta parcial">Respuesta parcial</option>
                                <option value="Sin respuesta">Sin respuesta</option>
                                <option value="Progresión">Progresión</option>
                            </select>
                        </div>
                        <div className="form-group" style={{ gridColumn: 'span 2' }}>
                            <label>Factores No Clínicos</label>
                            <textarea value={item.factores_no_clinicos || ''} onChange={e => onUpdate('riesgos', index, 'factores_no_clinicos', e.target.value)} />
                        </div>

                        <h4 style={{ gridColumn: 'span 2', marginTop: '20px' }}>Antecedentes Heredofamiliares</h4>
                        <div className="form-group checkbox-group">
                            <label className="checkbox-label" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <input
                                    type="checkbox"
                                    checked={item.antecedentes_heredofamiliares || false}
                                    onChange={e => onUpdate('riesgos', index, 'antecedentes_heredofamiliares', e.target.checked)}
                                    style={{ width: '20px', height: '20px' }}
                                />
                                Antecedentes Heredofamiliares
                            </label>
                        </div>
                        <div className="form-group" style={{ gridColumn: 'span 2' }}>
                            <label>Antecedentes Personales Patológicos</label>
                            <textarea value={item.antecedentes_personales_patologicos || ''} onChange={e => onUpdate('riesgos', index, 'antecedentes_personales_patologicos', e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>Medicamentos Hormonales</label>
                            <input type="text" value={item.medicamentos_hormonales || ''} onChange={e => onUpdate('riesgos', index, 'medicamentos_hormonales', e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>Edad de Menarquia</label>
                            <input type="number" value={item.edad_menarquia || ''} onChange={e => onUpdate('riesgos', index, 'edad_menarquia', parseInt(e.target.value))} />
                        </div>
                        <div className="form-group">
                            <label>Edad de Menopausia</label>
                            <input type="number" value={item.edad_menopausia || ''} onChange={e => onUpdate('riesgos', index, 'edad_menopausia', parseInt(e.target.value))} />
                        </div>
                        <div className="form-group">
                            <label>Número de Hijos</label>
                            <input type="number" value={item.numero_hijos || ''} onChange={e => onUpdate('riesgos', index, 'numero_hijos', parseInt(e.target.value))} />
                        </div>
                        <div className="form-group checkbox-group">
                            <label className="checkbox-label" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <input
                                    type="checkbox"
                                    checked={item.lactancia || false}
                                    onChange={e => onUpdate('riesgos', index, 'lactancia', e.target.checked)}
                                    style={{ width: '20px', height: '20px' }}
                                />
                                Lactancia
                            </label>
                        </div>
                    </div>
                </div>
            )) : <p>No hay evaluaciones de riesgo registradas.</p>}
        </div>
    </div>
);

const PatologiaSection = ({ data, onAdd, onUpdate }) => (
    <div className="ficha-section">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
            <h3>Patología (Historial)</h3>
            <button className="add-btn" onClick={() => onAdd('patologia')}>+ Registrar Patología</button>
        </div>
        <div className="section-list">
            {(data && data.length > 0) ? data.map((item, index) => (
                <div key={index} className="list-item-card" style={{ marginBottom: '30px', borderLeft: '4px solid #f59e0b' }}>
                    <div className="form-grid">
                        <div className="form-group">
                            <label>Fecha Procedimiento</label>
                            <input type="date" value={item.fecha_procedimiento?.split('T')[0] || ''} onChange={e => onUpdate('patologia', index, 'fecha_procedimiento', e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>Tipo Procedimiento</label>
                            <select value={item.tipo_procedimiento || ''} onChange={e => onUpdate('patologia', index, 'tipo_procedimiento', e.target.value)}>
                                <option value="">Seleccionar</option>
                                <option value="Biopsia Percutánea">Biopsia Percutánea</option>
                                <option value="Biopsia Incisional">Biopsia Incisional</option>
                                <option value="Biopsia Excisional">Biopsia Excisional</option>
                                <option value="Pieza Quirúrgica">Pieza Quirúrgica</option>
                                <option value="Revisión de Material">Revisión de Material</option>
                            </select>
                        </div>
                        <div className="form-group">
                            <label>Diagnóstico Histopatológico</label>
                            <input type="text" value={item.diagnostico || ''} onChange={e => onUpdate('patologia', index, 'diagnostico', e.target.value)} placeholder="Ej: Carcinoma Ductal Infiltrante" />
                        </div>
                        <div className="form-group">
                            <label>Estadificación de Patología (pTNM)</label>
                            <input type="text" value={item.estadificacion || ''} onChange={e => onUpdate('patologia', index, 'estadificacion', e.target.value)} placeholder="Ej: pT2 N1 M0" />
                        </div>
                        <div className="form-group">
                            <label>Tamaño del Tumor (Patología)</label>
                            <input type="text" value={item.tamano || ''} onChange={e => onUpdate('patologia', index, 'tamano', e.target.value)} placeholder="Ej: 2.4 cm" />
                        </div>
                        <div className="form-group checkbox-group">
                            <label className="checkbox-label" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <input
                                    type="checkbox"
                                    checked={item.transoperatorio || false}
                                    onChange={e => onUpdate('patologia', index, 'transoperatorio', e.target.checked)}
                                />
                                Incluye Transoperatorio
                            </label>
                        </div>

                        <h4 style={{ gridColumn: 'span 2', marginTop: '10px' }}>Inmunohistoquímica (Biomarcadores)</h4>
                        <div className="form-grid" style={{ gridColumn: 'span 2', background: '#f8fafc', padding: '15px', borderRadius: '8px' }}>
                            <div className="form-group">
                                <label>RE (Receptor Estrógeno)</label>
                                <input type="text" value={item.biomarcadores?.RE || ''} onChange={e => onUpdate('patologia', index, 'biomarcadores', { ...(item.biomarcadores || {}), RE: e.target.value })} placeholder="Ej: 90%" />
                            </div>
                            <div className="form-group">
                                <label>RP (Receptor Progesterona)</label>
                                <input type="text" value={item.biomarcadores?.RP || ''} onChange={e => onUpdate('patologia', index, 'biomarcadores', { ...(item.biomarcadores || {}), RP: e.target.value })} placeholder="Ej: 80%" />
                            </div>
                            <div className="form-group">
                                <label>HER2</label>
                                <select value={item.biomarcadores?.HER2 || ''} onChange={e => onUpdate('patologia', index, 'biomarcadores', { ...(item.biomarcadores || {}), HER2: e.target.value })}>
                                    <option value="">Seleccionar</option>
                                    <option value="Negativo (0)">Negativo (0)</option>
                                    <option value="Negativo (1+)">Negativo (1+)</option>
                                    <option value="Equívoco (2+)">Equívoco (2+)</option>
                                    <option value="Positivo (3+)">Positivo (3+)</option>
                                </select>
                            </div>
                            <div className="form-group">
                                <label>Ki-67</label>
                                <input type="text" value={item.biomarcadores?.Ki67 || ''} onChange={e => onUpdate('patologia', index, 'biomarcadores', { ...(item.biomarcadores || {}), Ki67: e.target.value })} placeholder="Ej: 20%" />
                            </div>
                        </div>

                        <div className="form-group" style={{ gridColumn: 'span 2' }}>
                            <label>Estudios Adicionales / Notas</label>
                            <textarea value={item.estudios_adicionales || ''} onChange={e => onUpdate('patologia', index, 'estudios_adicionales', e.target.value)} placeholder="Ej: FISH para HER2 equívoco..." />
                        </div>
                    </div>
                </div>
            )) : <p>No hay registros de patología. Use el botón "+ Registrar Patología".</p>}
        </div>
    </div>
);

const CirugiaSection = ({ data, onAdd, onUpdate }) => (
    <div className="ficha-section">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
            <h3>Cirugías (Historial)</h3>
            <button className="add-btn" onClick={() => onAdd('cirugia')}>+ Registrar Cirugía</button>
        </div>
        <div className="section-list">
            {(data && data.length > 0) ? data.map((item, index) => (
                <div key={index} className="list-item-card" style={{ marginBottom: '30px', borderLeft: '4px solid #6366f1' }}>
                    <div className="form-grid">
                        <div className="form-group">
                            <label>Fecha</label>
                            <input type="date" value={item.fecha?.split('T')[0] || ''} onChange={e => onUpdate('cirugia', index, 'fecha', e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>Tipo de Procedimiento</label>
                            <input type="text" value={item.tipo_procedimiento || ''} onChange={e => onUpdate('cirugia', index, 'tipo_procedimiento', e.target.value)} placeholder="Ej: Mastectomía Radical" />
                        </div>
                        <div className="form-group">
                            <label>Cirujano</label>
                            <input type="text" value={item.cirujano || ''} onChange={e => onUpdate('cirugia', index, 'cirujano', e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>Objetivo</label>
                            <select value={item.objetivo || ''} onChange={e => onUpdate('cirugia', index, 'objetivo', e.target.value)}>
                                <option value="">Seleccionar</option>
                                <option value="Curativo">Curativo</option>
                                <option value="Paliativo">Paliativo</option>
                                <option value="Reconstructivo">Reconstructivo</option>
                                <option value="Diagnóstico (Biopsia)">Diagnóstico (Biopsia)</option>
                            </select>
                        </div>
                        <div className="form-group" style={{ gridColumn: 'span 2' }}>
                            <label>Nota Quirúrgica / Hallazgos</label>
                            <textarea value={item.nota_quirurgica || ''} onChange={e => onUpdate('cirugia', index, 'nota_quirurgica', e.target.value)} />
                        </div>
                    </div>
                </div>
            )) : <p>No hay registros de cirugía.</p>}
        </div>
    </div>
);

const ComiteSection = ({ data, onAdd, onUpdate }) => (
    <div className="ficha-section">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
            <h3>Comité de Tumores (Historial)</h3>
            <button className="add-btn" onClick={() => onAdd('comite_tumores')}>+ Presentar en Comité</button>
        </div>
        <div className="section-list">
            {(data && data.length > 0) ? data.map((item, index) => (
                <div key={index} className="list-item-card" style={{ marginBottom: '30px', borderLeft: '4px solid #ec4899' }}>
                    <div className="form-grid">
                        <div className="form-group">
                            <label>Fecha Presentación</label>
                            <input type="date" value={item.fecha_presentacion?.split('T')[0] || ''} onChange={e => onUpdate('comite_tumores', index, 'fecha_presentacion', e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>Presentado por</label>
                            <input type="text" value={item.presentado_por || ''} onChange={e => onUpdate('comite_tumores', index, 'presentado_por', e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>Objetivo</label>
                            <input type="text" value={item.objetivo || ''} onChange={e => onUpdate('comite_tumores', index, 'objetivo', e.target.value)} placeholder="Ej: Decisión terapéutica inicial" />
                        </div>
                        <div className="form-group">
                            <label>Motivo</label>
                            <input type="text" value={item.motivo || ''} onChange={e => onUpdate('comite_tumores', index, 'motivo', e.target.value)} />
                        </div>
                        <div className="form-group" style={{ gridColumn: 'span 2' }}>
                            <label>Decisión / Conducta Acordada</label>
                            <textarea value={item.decision || ''} onChange={e => onUpdate('comite_tumores', index, 'decision', e.target.value)} placeholder="Ej: Iniciar neoadyuvancia con esquema AC-T..." />
                        </div>
                        <div className="form-group" style={{ gridColumn: 'span 2' }}>
                            <label>Notas adicionales</label>
                            <textarea value={item.nota || ''} onChange={e => onUpdate('comite_tumores', index, 'nota', e.target.value)} />
                        </div>
                    </div>
                </div>
            )) : <p>No se ha presentado en comité.</p>}
        </div>
    </div>
);

const RecurrenciaSection = ({ data, onAdd, onUpdate }) => (
    <div className="ficha-section">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
            <h3>Recurrencias (Historial)</h3>
            <button className="add-btn" onClick={() => onAdd('recurrencias')}>+ Registrar Recurrencia</button>
        </div>
        <div className="section-list">
            {(data && data.length > 0) ? data.map((item, index) => (
                <div key={index} className="list-item-card" style={{ marginBottom: '30px', borderLeft: '4px solid #ef4444' }}>
                    <div className="form-grid">
                        <div className="form-group">
                            <label>Fecha Detección</label>
                            <input type="date" value={item.fecha?.split('T')[0] || ''} onChange={e => onUpdate('recurrencias', index, 'fecha', e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>Tipo de Recurrencia</label>
                            <select value={item.tipo || ''} onChange={e => onUpdate('recurrencias', index, 'tipo', e.target.value)}>
                                <option value="">Seleccionar</option>
                                <option value="Local">Local</option>
                                <option value="Regional">Regional</option>
                                <option value="A distancia (Metástasis)">A distancia (Metástasis)</option>
                            </select>
                        </div>
                        <div className="form-group">
                            <label>Sitio de Recurrencia</label>
                            <input type="text" value={item.sitio || ''} onChange={e => onUpdate('recurrencias', index, 'sitio', e.target.value)} placeholder="Ej: Pulmón, Hueso, Axila..." />
                        </div>
                        <div className="form-group">
                            <label>Método Diagnóstico</label>
                            <input type="text" value={item.metodo_diagnostico || ''} onChange={e => onUpdate('recurrencias', index, 'metodo_diagnostico', e.target.value)} />
                        </div>
                        <div className="form-group" style={{ gridColumn: 'span 2' }}>
                            <label>Tratamiento de Recurrencia</label>
                            <textarea value={item.tratamiento_recurrencia || ''} onChange={e => onUpdate('recurrencias', index, 'tratamiento_recurrencia', e.target.value)} />
                        </div>
                        <div className="form-group" style={{ gridColumn: 'span 2' }}>
                            <label>Notas</label>
                            <textarea value={item.notas || ''} onChange={e => onUpdate('recurrencias', index, 'notas', e.target.value)} />
                        </div>
                    </div>
                </div>
            )) : <p>No hay recurrencias registradas (Paciente en remisión).</p>}
        </div>
    </div>
);

const DatosAdicionalesPatologiaSection = ({ data, onAdd, onUpdate }) => (
    <div className="ficha-section">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
            <h3>Patología Detallada (Historial)</h3>
            <button className="add-btn" onClick={() => onAdd('datos_adicionales_patologia')}>+ Agregar Detalle de Patología</button>
        </div>
        <div className="section-list">
            {(data && data.length > 0) ? data.map((item, index) => (
                <div key={index} className="list-item-card" style={{ marginBottom: '30px', borderLeft: '4px solid #f97316' }}>
                    <div className="form-grid">
                        <div className="form-group">
                            <label>Fecha de Reporte</label>
                            <input type="date" value={item.fecha?.split('T')[0] || ''} onChange={e => onUpdate('datos_adicionales_patologia', index, 'fecha', e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>Subtipo Molecular</label>
                            <select value={item.subtipo_molecular || ''} onChange={e => onUpdate('datos_adicionales_patologia', index, 'subtipo_molecular', e.target.value)}>
                                <option value="">Seleccionar</option>
                                <option value="Luminal A">Luminal A</option>
                                <option value="Luminal B">Luminal B</option>
                                <option value="HER2+ Pure">HER2+ Pure</option>
                                <option value="Triple Negativo">Triple Negativo</option>
                            </select>
                        </div>
                        <div className="form-group">
                            <label>Grado Histológico</label>
                            <input type="text" value={item.grado_histologico || ''} onChange={e => onUpdate('datos_adicionales_patologia', index, 'grado_histologico', e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>Márgenes Quirúrgicos</label>
                            <input type="text" value={item.margen_quirurgico || ''} onChange={e => onUpdate('datos_adicionales_patologia', index, 'margen_quirurgico', e.target.value)} placeholder="Ej: Libres (>2mm)" />
                        </div>
                        <div className="form-group">
                            <label>Ganglios Totales</label>
                            <input type="number" value={item.ganglios_totales || ''} onChange={e => onUpdate('datos_adicionales_patologia', index, 'ganglios_totales', parseInt(e.target.value))} />
                        </div>
                        <div className="form-group">
                            <label>Ganglios Positivos</label>
                            <input type="number" value={item.ganglios_positivos || ''} onChange={e => onUpdate('datos_adicionales_patologia', index, 'ganglios_positivos', parseInt(e.target.value))} />
                        </div>
                        <div className="form-group">
                            <label>Ki-67 (%)</label>
                            <input type="number" value={item.ki67_porcentaje || ''} onChange={e => onUpdate('datos_adicionales_patologia', index, 'ki67_porcentaje', parseFloat(e.target.value))} />
                        </div>
                        <div className="form-group checkbox-group">
                            <label className="checkbox-label" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <input type="checkbox" checked={item.invasion_linfovascular || false} onChange={e => onUpdate('datos_adicionales_patologia', index, 'invasion_linfovascular', e.target.checked)} />
                                Invasión Linfovascular
                            </label>
                        </div>
                    </div>
                </div>
            )) : <p>No hay detalles adicionales registrados.</p>}
        </div>
    </div>
);

const AtencionIntegralSection = ({ data, onAdd, onUpdate }) => (
    <div className="ficha-section">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
            <h3>Atención Integral (Historial)</h3>
            <button className="add-btn" onClick={() => onAdd('atencion_integral')}>+ Nuevo Registro Integral</button>
        </div>

        <div className="section-list">
            {(data && data.length > 0) ? data.map((item, index) => (
                <div key={index} className="list-item-card" style={{ marginBottom: '30px', borderLeft: '4px solid #10b981' }}>
                    <div className="form-grid">
                        <div className="form-group">
                            <label>Fecha de Registro</label>
                            <input type="date" value={item.fecha?.split('T')[0] || ''} onChange={e => onUpdate('atencion_integral', index, 'fecha', e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>Estado Funcional (ECOG)</label>
                            <select value={item.estado_funcional || ''} onChange={e => onUpdate('atencion_integral', index, 'estado_funcional', e.target.value)}>
                                <option value="">Seleccionar</option>
                                <option value="ECOG 0">ECOG 0 - Actividad normal</option>
                                <option value="ECOG 1">ECOG 1 - Síntomas leves</option>
                                <option value="ECOG 2">ECOG 2 - Ambulatorio &gt;50% del tiempo</option>
                                <option value="ECOG 3">ECOG 3 - En cama &gt;50% del tiempo</option>
                                <option value="ECOG 4">ECOG 4 - Totalmente en cama</option>
                            </select>
                        </div>
                        <div className="form-group checkbox-group">
                            <label className="checkbox-label" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <input
                                    type="checkbox"
                                    checked={item.paciente_red_apoyo || false}
                                    onChange={e => onUpdate('atencion_integral', index, 'paciente_red_apoyo', e.target.checked)}
                                    style={{ width: '20px', height: '20px' }}
                                />
                                Paciente en Red de Apoyo
                            </label>
                        </div>

                        <h4 style={{ gridColumn: 'span 2', marginTop: '20px' }}>Servicios de Atención</h4>
                        <div className="form-group" style={{ gridColumn: 'span 2' }}>
                            <label>Psicología</label>
                            <textarea
                                value={(item.psicologia || []).join(', ')}
                                onChange={e => onUpdate('atencion_integral', index, 'psicologia', e.target.value.split(',').map(s => s.trim()).filter(Boolean))}
                                placeholder="Ej: Apoyo psicológico oncológico, Terapia de grupo"
                            />
                        </div>
                        <div className="form-group" style={{ gridColumn: 'span 2' }}>
                            <label>Nutrición</label>
                            <textarea
                                value={(item.nutricion || []).join(', ')}
                                onChange={e => onUpdate('atencion_integral', index, 'nutricion', e.target.value.split(',').map(s => s.trim()).filter(Boolean))}
                                placeholder="Ej: Seguimiento nutricional, Plan alimenticio"
                            />
                        </div>
                        <div className="form-group" style={{ gridColumn: 'span 2' }}>
                            <label>Cuidados Paliativos</label>
                            <textarea
                                value={(item.cuidados_paliativos || []).join(', ')}
                                onChange={e => onUpdate('atencion_integral', index, 'cuidados_paliativos', e.target.value.split(',').map(s => s.trim()).filter(Boolean))}
                                placeholder="Ej: Control de síntomas, Cuidados de confort"
                            />
                        </div>
                        <div className="form-group" style={{ gridColumn: 'span 2' }}>
                            <label>Clínica del Dolor</label>
                            <textarea
                                value={(item.clinica_dolor || []).join(', ')}
                                onChange={e => onUpdate('atencion_integral', index, 'clinica_dolor', e.target.value.split(',').map(s => s.trim()).filter(Boolean))}
                                placeholder="Ej: Manejo de dolor oncológico"
                            />
                        </div>
                        <div className="form-group" style={{ gridColumn: 'span 2' }}>
                            <label>Rehabilitación</label>
                            <textarea
                                value={(item.rehabilitacion || []).join(', ')}
                                onChange={e => onUpdate('atencion_integral', index, 'rehabilitacion', e.target.value.split(',').map(s => s.trim()).filter(Boolean))}
                                placeholder="Ej: Fisioterapia post-quirúrgica, Rehabilitación de brazo"
                            />
                        </div>

                        <h4 style={{ gridColumn: 'span 2', marginTop: '20px' }}>Notas de Atención Integral</h4>
                        <div className="form-group" style={{ gridColumn: 'span 2' }}>
                            <div className="section-list">
                                {(item.notas_atencion_integral || []).map((nota, nIdx) => (
                                    <div key={nIdx} className="list-item-card">
                                        <div className="form-grid">
                                            <div className="form-group"><label>Fecha</label><input value={nota.fecha?.split('T')[0] || ''} readOnly /></div>
                                            <div className="form-group" style={{ gridColumn: 'span 2' }}><label>Nota</label><textarea value={nota.nota || ''} readOnly /></div>
                                        </div>
                                    </div>
                                ))}
                                {(!item.notas_atencion_integral || item.notas_atencion_integral.length === 0) && <p>No hay notas registradas en este evento.</p>}
                            </div>
                        </div>
                    </div>
                </div>
            )) : <p>No hay registros de atención integral.</p>}
        </div>
    </div>
);

const EtapaSection = ({ data, onAdd, onUpdate }) => (
    <div className="ficha-section">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
            <h3>Etapa Clínica (Historial)</h3>
            <button className="add-btn" onClick={() => onAdd('etapa_clinica')}>+ Nueva Estadificación</button>
        </div>

        <div className="section-list">
            {(data && data.length > 0) ? data.map((item, index) => (
                <div key={index} className="list-item-card" style={{ marginBottom: '30px', borderLeft: '4px solid #8b5cf6' }}>
                    <div className="form-grid">
                        <div className="form-group">
                            <label>Fecha de Estadificación</label>
                            <input type="date" value={item.fecha?.split('T')[0] || ''} onChange={e => onUpdate('etapa_clinica', index, 'fecha', e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>Etapa Global</label>
                            <input type="text" value={item.etapa || ''} onChange={e => onUpdate('etapa_clinica', index, 'etapa', e.target.value)} placeholder="Ej: IIB, IIIA" />
                        </div>
                        <div className="form-group">
                            <label>T (Tumor)</label>
                            <select value={item.cT || ''} onChange={e => onUpdate('etapa_clinica', index, 'cT', e.target.value)}>
                                <option value="">Seleccionar</option>
                                <option value="Tis">Tis - In situ</option>
                                <option value="T1">T1 - ≤2 cm</option>
                                <option value="T2">T2 - 2-5 cm</option>
                                <option value="T3">T3 - &gt;5 cm</option>
                                <option value="T4">T4 - Extensión a pared torácica/piel</option>
                            </select>
                        </div>
                        <div className="form-group">
                            <label>N (Nódulos)</label>
                            <select value={item.cN || ''} onChange={e => onUpdate('etapa_clinica', index, 'cN', e.target.value)}>
                                <option value="">Seleccionar</option>
                                <option value="N0">N0 - Sin ganglios</option>
                                <option value="N1">N1 - Axilares ipsilaterales móviles</option>
                                <option value="N2">N2 - Axilares ipsilaterales fijos</option>
                                <option value="N3">N3 - Mamaria interna ipsilateral</option>
                            </select>
                        </div>
                        <div className="form-group">
                            <label>M (Metástasis)</label>
                            <select value={item.cM || ''} onChange={e => onUpdate('etapa_clinica', index, 'cM', e.target.value)}>
                                <option value="">Seleccionar</option>
                                <option value="M0">M0 - Sin metástasis</option>
                                <option value="M1">M1 - Con metástasis a distancia</option>
                            </select>
                        </div>
                        <div className="form-group">
                            <label>Tamaño del Tumor</label>
                            <input type="text" value={item.tamano || ''} onChange={e => onUpdate('etapa_clinica', index, 'tamano', e.target.value)} placeholder="Ej: 3.5 cm" />
                        </div>
                        <div className="form-group" style={{ gridColumn: 'span 2' }}>
                            <label>Alteraciones de Piel</label>
                            <textarea value={item.alteraciones_piel || ''} onChange={e => onUpdate('etapa_clinica', index, 'alteraciones_piel', e.target.value)} placeholder="Ej: Retracción leve, edema, piel de naranja" />
                        </div>
                    </div>
                </div>
            )) : <p>No hay estadificaciones registradas.</p>}
        </div>
    </div>
);

const TratamientoSection = ({ neoadyuvantes, adyuvantes, paliativos, onAdd, onUpdate }) => (
    <div className="ficha-section">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
            <h3>Tratamientos (Historial)</h3>
        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '20px' }}>
            <h4>1. Neoadyuvancia (Antes de Cirugía)</h4>
            <button className="add-btn" onClick={() => onAdd('tratamientos_neoadyuvantes')}>+ Agregar Neoadyuvancia</button>
        </div>
        <div className="section-list">
            {(neoadyuvantes && neoadyuvantes.length > 0) ? neoadyuvantes.map((item, index) => (
                <div key={index} className="list-item-card" style={{ marginBottom: '20px', borderLeft: '4px solid #3b82f6' }}>
                    <div className="form-grid">
                        <div className="form-group">
                            <label>Tipo de Tratamiento</label>
                            <input type="text" value={item.tipo || ''} onChange={e => onUpdate('tratamientos_neoadyuvantes', index, 'tipo', e.target.value)} placeholder="Ej: Quimioterapia, Hormonoterapia" />
                        </div>
                        <div className="form-group">
                            <label>Esquema / Descripción</label>
                            <input type="text" value={item.descripcion || ''} onChange={e => onUpdate('tratamientos_neoadyuvantes', index, 'descripcion', e.target.value)} placeholder="Ej: AC-T" />
                        </div>
                        <div className="form-group">
                            <label>Fecha Inicio</label>
                            <input type="date" value={item.fecha_inicio?.split('T')[0] || ''} onChange={e => onUpdate('tratamientos_neoadyuvantes', index, 'fecha_inicio', e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>Respuesta</label>
                            <select value={item.respuesta || ''} onChange={e => onUpdate('tratamientos_neoadyuvantes', index, 'respuesta', e.target.value)}>
                                <option value="">Seleccionar</option>
                                <option value="Respuesta Completa">Respuesta Completa</option>
                                <option value="Respuesta Parcial">Respuesta Parcial</option>
                                <option value="Enfermedad Estable">Enfermedad Estable</option>
                                <option value="Progresión">Progresión</option>
                            </select>
                        </div>
                        <div className="form-group">
                            <label>Ciclos</label>
                            <input type="number" value={item.ciclos || ''} onChange={e => onUpdate('tratamientos_neoadyuvantes', index, 'ciclos', parseInt(e.target.value))} />
                        </div>
                    </div>
                </div>
            )) : <p>No hay tratamientos neoadyuvantes registrados.</p>}
        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '30px' }}>
            <h4>2. Adyuvancia (Después de Cirugía)</h4>
            <button className="add-btn" onClick={() => onAdd('tratamientos_adyuvantes')}>+ Agregar Adyuvancia</button>
        </div>
        <div className="section-list">
            {(adyuvantes && adyuvantes.length > 0) ? adyuvantes.map((item, index) => (
                <div key={index} className="list-item-card" style={{ marginBottom: '20px', borderLeft: '4px solid #8b5cf6' }}>
                    <div className="form-grid">
                        <div className="form-group">
                            <label>Tipo de Tratamiento</label>
                            <input type="text" value={item.tipo || ''} onChange={e => onUpdate('tratamientos_adyuvantes', index, 'tipo', e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>Esquema</label>
                            <input type="text" value={item.descripcion || ''} onChange={e => onUpdate('tratamientos_adyuvantes', index, 'descripcion', e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>Fecha Inicio</label>
                            <input type="date" value={item.fecha_inicio?.split('T')[0] || ''} onChange={e => onUpdate('tratamientos_adyuvantes', index, 'fecha_inicio', e.target.value)} />
                        </div>
                        <div className="form-group checkbox-group">
                            <label className="checkbox-label" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <input type="checkbox" checked={item.finalizado || false} onChange={e => onUpdate('tratamientos_adyuvantes', index, 'finalizado', e.target.checked)} />
                                Finalizado
                            </label>
                        </div>
                    </div>
                </div>
            )) : <p>No hay tratamientos adyuvantes registrados.</p>}
        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '30px' }}>
            <h4>3. Tratamientos Paliativos / Avanzados</h4>
            <button className="add-btn" onClick={() => onAdd('tratamientos_paliativos')}>+ Agregar Paliativo</button>
        </div>
        <div className="section-list">
            {(paliativos && paliativos.length > 0) ? paliativos.map((item, index) => (
                <div key={index} className="list-item-card" style={{ marginBottom: '20px', borderLeft: '4px solid #ef4444' }}>
                    <div className="form-grid">
                        <div className="form-group">
                            <label>Descripción</label>
                            <input type="text" value={item.descripcion || ''} onChange={e => onUpdate('tratamientos_paliativos', index, 'descripcion', e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>Fecha Inicio</label>
                            <input type="date" value={item.fecha_inicio?.split('T')[0] || ''} onChange={e => onUpdate('tratamientos_paliativos', index, 'fecha_inicio', e.target.value)} />
                        </div>
                    </div>
                </div>
            )) : <p>No hay tratamientos paliativos registrados.</p>}
        </div>
    </div>
);

const SeguimientoSection = ({ data, onAdd, onUpdate }) => (
    <div className="ficha-section">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
            <h3>Seguimiento Histórico</h3>
            <button className="add-btn" onClick={() => onAdd('seguimientos')}>+ Registrar Seguimiento</button>
        </div>
        <div className="section-list">
            {(data && data.length > 0) ? data.map((item, index) => (
                <div key={index} className="list-item-card" style={{ marginBottom: '30px', borderLeft: '4px solid #0ea5e9' }}>
                    <div className="form-grid">
                        <div className="form-group">
                            <label>Fecha</label>
                            <input type="date" value={item.fecha?.split('T')[0] || ''} onChange={e => onUpdate('seguimientos', index, 'fecha', e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>Tipo de Evento</label>
                            <select value={item.tipo_evento || ''} onChange={e => onUpdate('seguimientos', index, 'tipo_evento', e.target.value)}>
                                <option value="">Seleccionar</option>
                                <option value="Consulta de Seguimiento">Consulta de Seguimiento</option>
                                <option value="Estudio de Gabinete">Estudio de Gabinete</option>
                                <option value="Estudio de Laboratorio">Estudio de Laboratorio</option>
                                <option value="Urgencia">Urgencia</option>
                                <option value="Defunción">Defunción</option>
                            </select>
                        </div>
                        <div className="form-group">
                            <label>BIRADS (Si aplica)</label>
                            <input type="text" value={item.birads || ''} onChange={e => onUpdate('seguimientos', index, 'birads', e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>Recomendación / Conducta</label>
                            <input type="text" value={item.recomendacion || ''} onChange={e => onUpdate('seguimientos', index, 'recomendacion', e.target.value)} />
                        </div>
                        <div className="form-group" style={{ gridColumn: 'span 2' }}>
                            <label>Hallazgos Detectados</label>
                            <textarea value={item.descripcion_hallazgo || ''} onChange={e => onUpdate('seguimientos', index, 'descripcion_hallazgo', e.target.value)} />
                        </div>
                        <div className="form-group checkbox-group">
                            <label className="checkbox-label" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <input type="checkbox" checked={item.defuncion || false} onChange={e => onUpdate('seguimientos', index, 'defuncion', e.target.checked)} />
                                Defunción
                            </label>
                        </div>
                        {item.defuncion && (
                            <div className="form-group">
                                <label>Fecha de Defunción</label>
                                <input type="date" value={item.fecha_de_defuncion?.split('T')[0] || ''} onChange={e => onUpdate('seguimientos', index, 'fecha_de_defuncion', e.target.value)} />
                            </div>
                        )}
                    </div>
                </div>
            )) : <p>No hay seguimientos registrados.</p>}
        </div>
    </div>
);

// ==================== NEW CLINICAL SECTIONS ====================

const RadioterapiaSection = ({ data, onAdd, onUpdate }) => (
    <div className="ficha-section">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
            <h3>Radioterapia (Historial)</h3>
            <button className="add-btn" onClick={() => onAdd('radioterapia')}>+ Registrar Radioterapia</button>
        </div>
        <div className="section-list">
            {(data && data.length > 0) ? data.map((item, index) => (
                <div key={index} className="list-item-card" style={{ marginBottom: '20px', borderLeft: '4px solid #f59e0b' }}>
                    <div className="form-grid">
                        <div className="form-group">
                            <label>Fecha Inicio</label>
                            <input type="date" value={item.fecha_inicio?.split('T')[0] || ''} onChange={e => onUpdate('radioterapia', index, 'fecha_inicio', e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>Fecha Fin</label>
                            <input type="date" value={item.fecha_fin?.split('T')[0] || ''} onChange={e => onUpdate('radioterapia', index, 'fecha_fin', e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>Tipo</label>
                            <input type="text" value={item.tipo || ''} onChange={e => onUpdate('radioterapia', index, 'tipo', e.target.value)} placeholder="Externa, IMRT, Braquiterapia" />
                        </div>
                        <div className="form-group">
                            <label>Dosis Total (Gy)</label>
                            <input type="number" step="0.1" value={item.dosis_total_gy || ''} onChange={e => onUpdate('radioterapia', index, 'dosis_total_gy', parseFloat(e.target.value))} />
                        </div>
                        <div className="form-group">
                            <label>Fraccionamiento</label>
                            <input type="text" value={item.fraccionamiento || ''} onChange={e => onUpdate('radioterapia', index, 'fraccionamiento', e.target.value)} placeholder="Ej: 25 fracciones de 2 Gy" />
                        </div>
                        <div className="form-group">
                            <label>Área Tratada</label>
                            <input type="text" value={item.area_tratada || ''} onChange={e => onUpdate('radioterapia', index, 'area_tratada', e.target.value)} placeholder="Mama, Lecho, Axilar, Supraclavicular" />
                        </div>
                        <div className="form-group">
                            <label>Toxicidad Aguda</label>
                            <input type="text" value={item.toxicidad_aguda || ''} onChange={e => onUpdate('radioterapia', index, 'toxicidad_aguda', e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>Toxicidad Tardía</label>
                            <input type="text" value={item.toxicidad_tardia || ''} onChange={e => onUpdate('radioterapia', index, 'toxicidad_tardia', e.target.value)} />
                        </div>
                        <div className="form-group checkbox-group">
                            <label className="checkbox-label" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <input type="checkbox" checked={item.suspension || false} onChange={e => onUpdate('radioterapia', index, 'suspension', e.target.checked)} />
                                Suspensión
                            </label>
                        </div>
                        {item.suspension && (
                            <div className="form-group">
                                <label>Motivo de Suspensión</label>
                                <input type="text" value={item.motivo_suspension || ''} onChange={e => onUpdate('radioterapia', index, 'motivo_suspension', e.target.value)} />
                            </div>
                        )}
                        <div className="form-group" style={{ gridColumn: 'span 2' }}>
                            <label>Notas</label>
                            <textarea value={item.notas || ''} onChange={e => onUpdate('radioterapia', index, 'notas', e.target.value)} />
                        </div>
                    </div>
                </div>
            )) : <p>No hay registros de radioterapia.</p>}
        </div>
    </div>
);

const InmunoterapiaSection = ({ data, onAdd, onUpdate }) => (
    <div className="ficha-section">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
            <h3>Inmunoterapia (Historial)</h3>
            <button className="add-btn" onClick={() => onAdd('inmunoterapia')}>+ Registrar Inmunoterapia</button>
        </div>
        <div className="section-list">
            {(data && data.length > 0) ? data.map((item, index) => (
                <div key={index} className="list-item-card" style={{ marginBottom: '20px', borderLeft: '4px solid #8b5cf6' }}>
                    <div className="form-grid">
                        <div className="form-group">
                            <label>Fecha Inicio</label>
                            <input type="date" value={item.fecha_inicio?.split('T')[0] || ''} onChange={e => onUpdate('inmunoterapia', index, 'fecha_inicio', e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>Fecha Fin</label>
                            <input type="date" value={item.fecha_fin?.split('T')[0] || ''} onChange={e => onUpdate('inmunoterapia', index, 'fecha_fin', e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>Tipo</label>
                            <input type="text" value={item.tipo || ''} onChange={e => onUpdate('inmunoterapia', index, 'tipo', e.target.value)} placeholder="Pembrolizumab, Atezolizumab" />
                        </div>
                        <div className="form-group">
                            <label>Ciclos</label>
                            <input type="number" value={item.ciclos || ''} onChange={e => onUpdate('inmunoterapia', index, 'ciclos', parseInt(e.target.value))} />
                        </div>
                        <div className="form-group">
                            <label>Respuesta</label>
                            <input type="text" value={item.respuesta || ''} onChange={e => onUpdate('inmunoterapia', index, 'respuesta', e.target.value)} />
                        </div>
                        <div className="form-group" style={{ gridColumn: 'span 2' }}>
                            <label>Eventos Adversos Inmunomediados</label>
                            <textarea value={item.eventos_adversos_inmunomediados || ''} onChange={e => onUpdate('inmunoterapia', index, 'eventos_adversos_inmunomediados', e.target.value)} />
                        </div>
                        <div className="form-group checkbox-group">
                            <label className="checkbox-label" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <input type="checkbox" checked={item.suspension || false} onChange={e => onUpdate('inmunoterapia', index, 'suspension', e.target.checked)} />
                                Suspensión
                            </label>
                        </div>
                        {item.suspension && (
                            <div className="form-group">
                                <label>Motivo de Suspensión</label>
                                <input type="text" value={item.motivo_suspension || ''} onChange={e => onUpdate('inmunoterapia', index, 'motivo_suspension', e.target.value)} />
                            </div>
                        )}
                        <div className="form-group" style={{ gridColumn: 'span 2' }}>
                            <label>Notas</label>
                            <textarea value={item.notas || ''} onChange={e => onUpdate('inmunoterapia', index, 'notas', e.target.value)} />
                        </div>
                    </div>
                </div>
            )) : <p>No hay registros de inmunoterapia.</p>}
        </div>
    </div>
);

const TerapiaDirigidaSection = ({ data, onAdd, onUpdate }) => (
    <div className="ficha-section">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
            <h3>Terapia Dirigida (Historial)</h3>
            <button className="add-btn" onClick={() => onAdd('terapia_dirigida')}>+ Registrar Terapia Dirigida</button>
        </div>
        <div className="section-list">
            {(data && data.length > 0) ? data.map((item, index) => (
                <div key={index} className="list-item-card" style={{ marginBottom: '20px', borderLeft: '4px solid #ec4899' }}>
                    <div className="form-grid">
                        <div className="form-group">
                            <label>Fecha Inicio</label>
                            <input type="date" value={item.fecha_inicio?.split('T')[0] || ''} onChange={e => onUpdate('terapia_dirigida', index, 'fecha_inicio', e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>Fecha Fin</label>
                            <input type="date" value={item.fecha_fin?.split('T')[0] || ''} onChange={e => onUpdate('terapia_dirigida', index, 'fecha_fin', e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>Tipo</label>
                            <input type="text" value={item.tipo || ''} onChange={e => onUpdate('terapia_dirigida', index, 'tipo', e.target.value)} placeholder="Trastuzumab, Pertuzumab, T-DM1" />
                        </div>
                        <div className="form-group">
                            <label>Indicación</label>
                            <input type="text" value={item.indicacion || ''} onChange={e => onUpdate('terapia_dirigida', index, 'indicacion', e.target.value)} placeholder="Neoadyuvante, Adyuvante, Metastásico" />
                        </div>
                        <div className="form-group">
                            <label>Duración Planificada (meses)</label>
                            <input type="number" value={item.duracion_planificada_meses || ''} onChange={e => onUpdate('terapia_dirigida', index, 'duracion_planificada_meses', parseInt(e.target.value))} />
                        </div>
                        <div className="form-group">
                            <label>FEVI Basal (%)</label>
                            <input type="number" step="0.1" value={item.fevi_basal || ''} onChange={e => onUpdate('terapia_dirigida', index, 'fevi_basal', parseFloat(e.target.value))} />
                        </div>
                        <div className="form-group checkbox-group">
                            <label className="checkbox-label" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <input type="checkbox" checked={item.cardiotoxicidad || false} onChange={e => onUpdate('terapia_dirigida', index, 'cardiotoxicidad', e.target.checked)} />
                                Cardiotoxicidad
                            </label>
                        </div>
                        <div className="form-group checkbox-group">
                            <label className="checkbox-label" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <input type="checkbox" checked={item.suspension || false} onChange={e => onUpdate('terapia_dirigida', index, 'suspension', e.target.checked)} />
                                Suspensión
                            </label>
                        </div>
                        {item.suspension && (
                            <div className="form-group">
                                <label>Motivo de Suspensión</label>
                                <input type="text" value={item.motivo_suspension || ''} onChange={e => onUpdate('terapia_dirigida', index, 'motivo_suspension', e.target.value)} />
                            </div>
                        )}
                        <div className="form-group" style={{ gridColumn: 'span 2' }}>
                            <label>Notas</label>
                            <textarea value={item.notas || ''} onChange={e => onUpdate('terapia_dirigida', index, 'notas', e.target.value)} />
                        </div>
                    </div>
                </div>
            )) : <p>No hay registros de terapia dirigida.</p>}
        </div>
    </div>
);

const EstudiosImagenSection = ({ data, onAdd, onUpdate }) => (
    <div className="ficha-section">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
            <h3>Estudios de Imagen (Historial)</h3>
            <button className="add-btn" onClick={() => onAdd('estudios_imagen')}>+ Registrar Estudio</button>
        </div>
        <div className="section-list">
            {(data && data.length > 0) ? data.map((item, index) => (
                <div key={index} className="list-item-card" style={{ marginBottom: '20px', borderLeft: '4px solid #10b981' }}>
                    <div className="form-grid">
                        <div className="form-group">
                            <label>Fecha</label>
                            <input type="date" value={item.fecha?.split('T')[0] || ''} onChange={e => onUpdate('estudios_imagen', index, 'fecha', e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>Tipo de Estudio</label>
                            <input type="text" value={item.tipo_estudio || ''} onChange={e => onUpdate('estudios_imagen', index, 'tipo_estudio', e.target.value)} placeholder="TAC, RMN, PET-CT, Gammagrafía" />
                        </div>
                        <div className="form-group">
                            <label>Indicación</label>
                            <input type="text" value={item.indicacion || ''} onChange={e => onUpdate('estudios_imagen', index, 'indicacion', e.target.value)} placeholder="Estadificación, Seguimiento" />
                        </div>
                        <div className="form-group" style={{ gridColumn: 'span 2' }}>
                            <label>Hallazgos Principales</label>
                            <textarea value={item.hallazgos_principales || ''} onChange={e => onUpdate('estudios_imagen', index, 'hallazgos_principales', e.target.value)} />
                        </div>
                        <div className="form-group" style={{ gridColumn: 'span 2' }}>
                            <label>Conclusión</label>
                            <textarea value={item.conclusion || ''} onChange={e => onUpdate('estudios_imagen', index, 'conclusion', e.target.value)} />
                        </div>
                        <div className="form-group" style={{ gridColumn: 'span 2' }}>
                            <label>Notas</label>
                            <textarea value={item.notas || ''} onChange={e => onUpdate('estudios_imagen', index, 'notas', e.target.value)} />
                        </div>
                    </div>
                </div>
            )) : <p>No hay estudios de imagen registrados.</p>}
        </div>
    </div>
);

const GeneticaSection = ({ data, onAdd, onUpdate }) => (
    <div className="ficha-section">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
            <h3>Genética / Consejo Genético (Historial)</h3>
            <button className="add-btn" onClick={() => onAdd('genetica')}>+ Registrar Consejería</button>
        </div>
        <div className="section-list">
            {(data && data.length > 0) ? data.map((item, index) => (
                <div key={index} className="list-item-card" style={{ marginBottom: '20px', borderLeft: '4px solid #6366f1' }}>
                    <div className="form-grid">
                        <div className="form-group">
                            <label>Fecha de Consejería</label>
                            <input type="date" value={item.fecha_consejeria?.split('T')[0] || ''} onChange={e => onUpdate('genetica', index, 'fecha_consejeria', e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>Indicación</label>
                            <input type="text" value={item.indicacion || ''} onChange={e => onUpdate('genetica', index, 'indicacion', e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>Genes Estudiados</label>
                            <input type="text" value={item.genes_estudiados || ''} onChange={e => onUpdate('genetica', index, 'genes_estudiados', e.target.value)} placeholder="BRCA1, BRCA2, PALB2" />
                        </div>
                        <div className="form-group">
                            <label>Resultado</label>
                            <input type="text" value={item.resultado || ''} onChange={e => onUpdate('genetica', index, 'resultado', e.target.value)} placeholder="Positivo, Negativo, VUS" />
                        </div>
                        <div className="form-group" style={{ gridColumn: 'span 2' }}>
                            <label>Variante Detectada</label>
                            <input type="text" value={item.variante_detectada || ''} onChange={e => onUpdate('genetica', index, 'variante_detectada', e.target.value)} />
                        </div>
                        <div className="form-group" style={{ gridColumn: 'span 2' }}>
                            <label>Implicaciones Familiares</label>
                            <textarea value={item.implicaciones_familiares || ''} onChange={e => onUpdate('genetica', index, 'implicaciones_familiares', e.target.value)} />
                        </div>
                        <div className="form-group checkbox-group">
                            <label className="checkbox-label" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <input type="checkbox" checked={item.cirugia_profilactica_recomendada || false} onChange={e => onUpdate('genetica', index, 'cirugia_profilactica_recomendada', e.target.checked)} />
                                Cirugía Profiláctica Recomendada
                            </label>
                        </div>
                        <div className="form-group" style={{ gridColumn: 'span 2' }}>
                            <label>Notas</label>
                            <textarea value={item.notas || ''} onChange={e => onUpdate('genetica', index, 'notas', e.target.value)} />
                        </div>
                    </div>
                </div>
            )) : <p>No hay registros de genética.</p>}
        </div>
    </div>
);

const ReconstruccionSection = ({ data, onAdd, onUpdate }) => (
    <div className="ficha-section">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
            <h3>Reconstrucción Mamaria (Historial)</h3>
            <button className="add-btn" onClick={() => onAdd('reconstruccion_mamaria')}>+ Registrar Reconstrucción</button>
        </div>
        <div className="section-list">
            {(data && data.length > 0) ? data.map((item, index) => (
                <div key={index} className="list-item-card" style={{ marginBottom: '20px', borderLeft: '4px solid #f97316' }}>
                    <div className="form-grid">
                        <div className="form-group">
                            <label>Fecha</label>
                            <input type="date" value={item.fecha?.split('T')[0] || ''} onChange={e => onUpdate('reconstruccion_mamaria', index, 'fecha', e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>Tipo</label>
                            <input type="text" value={item.tipo || ''} onChange={e => onUpdate('reconstruccion_mamaria', index, 'tipo', e.target.value)} placeholder="Inmediata, Diferida" />
                        </div>
                        <div className="form-group">
                            <label>Técnica</label>
                            <input type="text" value={item.tecnica || ''} onChange={e => onUpdate('reconstruccion_mamaria', index, 'tecnica', e.target.value)} placeholder="Implante, Colgajo DIEP, TRAM" />
                        </div>
                        <div className="form-group">
                            <label>Cirujano Plástico</label>
                            <input type="text" value={item.cirujano_plastico || ''} onChange={e => onUpdate('reconstruccion_mamaria', index, 'cirujano_plastico', e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>Complicaciones</label>
                            <input type="text" value={item.complicaciones || ''} onChange={e => onUpdate('reconstruccion_mamaria', index, 'complicaciones', e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>Resultado Estético</label>
                            <select value={item.resultado_estetico || ''} onChange={e => onUpdate('reconstruccion_mamaria', index, 'resultado_estetico', e.target.value)}>
                                <option value="">Seleccionar...</option>
                                <option value="Excelente">Excelente</option>
                                <option value="Bueno">Bueno</option>
                                <option value="Regular">Regular</option>
                                <option value="Pobre">Pobre</option>
                            </select>
                        </div>
                        <div className="form-group" style={{ gridColumn: 'span 2' }}>
                            <label>Notas</label>
                            <textarea value={item.notas || ''} onChange={e => onUpdate('reconstruccion_mamaria', index, 'notas', e.target.value)} />
                        </div>
                    </div>
                </div>
            )) : <p>No hay registros de reconstrucción mamaria.</p>}
        </div>
    </div>
);

const ResumenClinico = ({ data }) => {
    const formatDate = (dateStr) => dateStr ? new Date(dateStr).toLocaleDateString('es-MX', { day: '2-digit', month: 'short', year: 'numeric' }) : 'N/A';

    const latestEtapa = (data.etapa_clinica && data.etapa_clinica.length > 0) ? data.etapa_clinica[0] : {};
    const latestRiesgo = (data.riesgos && data.riesgos.length > 0) ? data.riesgos[0] : {};
    const latestAtencion = (data.atencion_integral && data.atencion_integral.length > 0) ? data.atencion_integral[0] : {};

    return (
        <div className="ficha-resumen-proyeccion" style={{
            padding: '30px',
            backgroundColor: '#0f172a',
            color: '#f8fafc',
            fontFamily: "'Inter', sans-serif",
            minHeight: '85vh',
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)',
            gridTemplateRows: 'auto auto 1fr auto',
            gap: '20px'
        }}>
            {/* Header Dashboard */}
            <div style={{ gridColumn: 'span 3', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '2px solid #334155', paddingBottom: '15px' }}>
                <div>
                    <h1 style={{ margin: 0, fontSize: '2.4em', color: '#38bdf8', letterSpacing: '-1px' }}>FICHA ONCOLÓGICA CRÍTICA</h1>
                    <div style={{ fontSize: '1.1em', color: '#94a3b8' }}>Centro de Decisiones Oncológicas • {new Date().toLocaleDateString()}</div>
                </div>
                <div style={{ textAlign: 'right', backgroundColor: '#1e293b', padding: '10px 20px', borderRadius: '12px', border: '1px solid #334155' }}>
                    <div style={{ fontSize: '1.4em', fontWeight: 'bold' }}>{data.patient_name || 'Paciente de Prueba'}</div>
                    <div style={{ color: '#38bdf8' }}>Edad: {data.demograficos?.edad} • ID: {data.patient_id?.split('@')[0].toUpperCase()}</div>
                </div>
            </div>

            {/* Fila 1: Datos Vitales y Riesgos */}
            <div className="dashboard-card" style={{ backgroundColor: '#1e293b', padding: '20px', borderRadius: '16px', borderLeft: '6px solid #ef4444' }}>
                <h3 style={{ margin: '0 0 15px 0', color: '#94a3b8', fontSize: '1em', textTransform: 'uppercase' }}>Clínica / Riesgos</h3>
                <div style={{ fontSize: '1.2em', lineHeight: '1.6' }}>
                    <div style={{ marginBottom: '10px' }}><span style={{ color: '#94a3b8' }}>Motivo:</span> <br /> <strong>{data.demograficos?.motivo_consulta}</strong></div>
                    <div><span style={{ color: '#ef4444', fontWeight: 'bold', fontSize: '1.2em' }}>⚠️ Riesgo:</span> {latestRiesgo.riesgo_identificado || 'Bajo'}</div>
                </div>
            </div>

            <div className="dashboard-card" style={{ backgroundColor: '#1e293b', padding: '20px', borderRadius: '16px', borderLeft: '6px solid #38bdf8' }}>
                <h3 style={{ margin: '0 0 15px 0', color: '#94a3b8', fontSize: '1em', textTransform: 'uppercase' }}>Etapa Clínica Actual</h3>
                <div style={{ textAlign: 'center' }}>
                    <div style={{ fontSize: '4.5em', fontWeight: '900', color: '#38bdf8', lineHeight: '1' }}>{latestEtapa.etapa || '?'}</div>
                    <div style={{ fontSize: '1.4em', marginTop: '10px' }}>T:{latestEtapa.cT || 'x'} N:{latestEtapa.cN || 'x'} M:{latestEtapa.cM || 'x'}</div>
                </div>
            </div>

            <div className="dashboard-card" style={{ backgroundColor: '#1e293b', padding: '20px', borderRadius: '16px', borderLeft: '6px solid #22c55e' }}>
                <h3 style={{ margin: '0 0 15px 0', color: '#94a3b8', fontSize: '1em', textTransform: 'uppercase' }}>Estatus de Atención</h3>
                <div style={{ fontSize: '1.2em' }}>
                    <div style={{ marginBottom: '10px' }}>ECOG: <strong style={{ fontSize: '1.5em', color: '#22c55e' }}>{latestAtencion.estado_funcional || '0'}</strong></div>
                    <div>Metástasis Debut: <span style={{ color: latestRiesgo.paciente_debuto_etapa4 ? '#ef4444' : '#22c55e' }}>{latestRiesgo.paciente_debuto_etapa4 ? 'SÍ' : 'NO'}</span></div>
                    <div style={{ marginTop: '15px', fontSize: '0.85em', color: '#94a3b8' }}>Último Seg: {formatDate(data.seguimientos?.[0]?.fecha)}</div>
                </div>
            </div>

            {/* Fila 2: Imagen y Patología */}
            <div style={{ gridColumn: 'span 1', display: 'flex', flexDirection: 'column', gap: '20px' }}>
                <div className="dashboard-card" style={{ backgroundColor: '#1e293b', padding: '20px', borderRadius: '16px', flex: 1 }}>
                    <h3 style={{ margin: '0 0 15px 0', color: '#94a3b8', fontSize: '1em', textTransform: 'uppercase' }}>Hallazgos / Imagen</h3>
                    <div style={{ display: 'flex', gap: '10px', height: '180px' }}>
                        {data.esquema_mamario_url ? <img src={data.esquema_mamario_url} alt="Mamario" style={{ width: '48%', objectFit: 'cover', borderRadius: '8px' }} /> : <div style={{ width: '48%', backgroundColor: '#0f172a', borderRadius: '8px' }}></div>}
                        {data.esquema_axilar_url ? <img src={data.esquema_axilar_url} alt="Axilar" style={{ width: '48%', objectFit: 'cover', borderRadius: '8px' }} /> : <div style={{ width: '48%', backgroundColor: '#0f172a', borderRadius: '8px' }}></div>}
                    </div>
                </div>
            </div>

            <div className="dashboard-card" style={{ gridColumn: 'span 2', backgroundColor: '#1e293b', padding: '20px', borderRadius: '16px' }}>
                <h3 style={{ margin: '0 0 15px 0', color: '#94a3b8', fontSize: '1em', textTransform: 'uppercase' }}>Patología Crítica (Biomarcadores)</h3>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
                    {(data.patologia || []).slice(0, 2).map((p, i) => (
                        <div key={i} style={{ backgroundColor: '#0f172a', padding: '15px', borderRadius: '12px', border: '1px solid #334155' }}>
                            <div style={{ fontWeight: 'bold', fontSize: '0.9em', borderBottom: '1px solid #334155', paddingBottom: '5px', marginBottom: '10px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                {formatDate(p.fecha_procedimiento)} - {p.diagnostico}
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-around', textAlign: 'center' }}>
                                <div><div style={{ color: '#94a3b8', fontSize: '0.75em' }}>RE</div><div style={{ fontSize: '1.2em', fontWeight: 'bold' }}>{p.biomarcadores?.RE || '-'}</div></div>
                                <div><div style={{ color: '#94a3b8', fontSize: '0.75em' }}>RP</div><div style={{ fontSize: '1.2em', fontWeight: 'bold' }}>{p.biomarcadores?.RP || '-'}</div></div>
                                <div><div style={{ color: '#94a3b8', fontSize: '0.75em' }}>Ki67</div><div style={{ fontSize: '1.2em', fontWeight: 'bold', color: '#eab308' }}>{p.biomarcadores?.Ki67 || '-'}</div></div>
                                <div><div style={{ color: '#94a3b8', fontSize: '0.75em' }}>HER2</div><div style={{ fontSize: '1.2em', fontWeight: 'bold', color: '#38bdf8' }}>{p.biomarcadores?.HER2 || '-'}</div></div>
                            </div>
                        </div>
                    ))}
                    {(!data.patologia?.length) && <div style={{ gridColumn: 'span 2', textAlign: 'center', color: '#94a3b8' }}>Sin registros patológicos</div>}
                </div>
            </div>

            {/* Fila 3: Tratamiento y Cronología */}
            <div className="dashboard-card" style={{ gridColumn: 'span 3', backgroundColor: '#1e293b', padding: '20px', borderRadius: '16px', overflow: 'hidden' }}>
                <h3 style={{ margin: '0 0 15px 0', color: '#94a3b8', fontSize: '1em', textTransform: 'uppercase' }}>Línea de Tiempo Operativa</h3>
                <div style={{ display: 'flex', gap: '15px', overflowX: 'auto', paddingBottom: '5px' }}>
                    {data.tratamientos_neoadyuvantes?.map((t, i) => (
                        <div key={i} style={{ minWidth: '220px', backgroundColor: '#312e81', padding: '12px', borderRadius: '12px', border: '1px solid #4338ca' }}>
                            <div style={{ color: '#818cf8', fontWeight: 'bold', fontSize: '0.8em' }}>NEOADYUVANCIA</div>
                            <div style={{ fontSize: '1em', marginTop: '5px', fontWeight: 'bold' }}>{t.descripcion}</div>
                            <div style={{ fontSize: '0.85em', color: '#94a3b8' }}>Ciclos: {t.ciclos || '8'} • {t.respuesta || '-'}</div>
                        </div>
                    ))}
                    {data.cirugia?.map((c, i) => (
                        <div key={i} style={{ minWidth: '220px', backgroundColor: '#1e293b', padding: '12px', borderRadius: '12px', border: '1px solid #334155' }}>
                            <div style={{ color: '#22c55e', fontWeight: 'bold', fontSize: '0.8em' }}>CIRUGÍA ({formatDate(c.fecha)})</div>
                            <div style={{ fontSize: '0.95em', marginTop: '5px' }}>{c.tipo_procedimiento}</div>
                        </div>
                    ))}
                    {data.comite_tumores?.slice(-1).map((com, i) => (
                        <div key={i} style={{ minWidth: '300px', backgroundColor: '#4c1d95', padding: '12px', borderRadius: '12px', border: '1px solid #7c3aed' }}>
                            <div style={{ color: '#a78bfa', fontWeight: 'bold', fontSize: '0.8em' }}>ÚLTIMA DECISIÓN COMITÉ</div>
                            <div style={{ fontSize: '0.9em', marginTop: '5px', fontStyle: 'italic' }}>"{com.decision?.substring(0, 100)}..."</div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Footer */}
            <div style={{ gridColumn: 'span 3', textAlign: 'center', fontSize: '0.8em', color: '#64748b', borderTop: '1px solid #334155', paddingTop: '10px' }}>
                VÍKI V2.0 • PROTOCOLO DE ALTA COMPLEJIDAD • {new Date().toLocaleTimeString()}
            </div>
        </div>
    );
};


const AnexosSection = ({ data, esquemas }) => (
    <div className="ficha-section">
        <h3>Esquemas y Anexos</h3>

        <div className="esquemas-container" style={{ display: 'flex', gap: '20px', marginBottom: '30px' }}>
            <div className="esquema-preview" style={{ border: '1px solid #ddd', padding: '10px', borderRadius: '8px', flex: 1 }}>
                <h4>Esquema Mamario</h4>
                {esquemas?.mamario ? (
                    <img src={esquemas.mamario} alt="Esquema Mamario" style={{ width: '100%', borderRadius: '4px' }} />
                ) : <p className="notes">No disponible</p>}
            </div>
            <div className="esquema-preview" style={{ border: '1px solid #ddd', padding: '10px', borderRadius: '8px', flex: 1 }}>
                <h4>Esquema Axilar</h4>
                {esquemas?.axilar ? (
                    <img src={esquemas.axilar} alt="Esquema Axilar" style={{ width: '100%', borderRadius: '4px' }} />
                ) : <p className="notes">No disponible</p>}
            </div>
        </div>

        <h3>Archivos Adjuntos</h3>
        <div className="section-list">
            {(data || []).map((item, index) => (
                <div key={index} className="list-item-card file-card" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div>
                        <div style={{ fontWeight: 'bold', color: '#880e4f' }}>{item.nombre}</div>
                        <div style={{ fontSize: '0.85em', color: '#7f8c8d' }}>{item.tipo} - {item.fecha?.split('T')[0]}</div>
                        <div style={{ fontStyle: 'italic' }}>{item.descripcion}</div>
                    </div>
                    <a href={item.url} target="_blank" rel="noreferrer" className="btn-primary" style={{ textDecoration: 'none', padding: '5px 15px', fontSize: '0.9em' }}>
                        Ver
                    </a>
                </div>
            ))}
            {(!data || data.length === 0) && <p>No hay archivos adjuntos.</p>}
        </div>
    </div>
);


const FichaContainer = ({ user, onClose }) => {
    const [activeTab, setActiveTab] = useState('demograficos');
    const [isProjectionMode, setIsProjectionMode] = useState(false);
    const [fichaData, setFichaData] = useState({
        demograficos: {},
        hallazgos: [],
        riesgos: [],
        atencion_integral: [],
        etapa_clinica: [],
        tratamientos_neoadyuvantes: [],
        tratamientos_adyuvantes: [],
        tratamientos_paliativos: [],
        seguimientos: [],
        recurrencias: [],
        datos_adicionales_patologia: [],
        patologia: [],
        cirugia: [],
        comite_tumores: [],
        anexos: [],
        esquema_mamario_url: null,
        esquema_axilar_url: null,
        // New Clinical Sections
        radioterapia: [],
        inmunoterapia: [],
        terapia_dirigida: [],
        estudios_imagen: [],
        genetica: [],
        reconstruccion_mamaria: []
    });

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [successMsg, setSuccessMsg] = useState(null);

    useEffect(() => {
        const loadFicha = async () => {
            setLoading(true);
            try {
                const patientId = user.email;
                const data = await getFicha(patientId);
                if (data) {
                    const formattedData = {
                        ...data,
                        patient_name: `${user.first_name} ${user.last_name}`
                    };
                    setFichaData(prev => ({ ...prev, ...formattedData }));
                }
            } catch (err) {
                console.error("Error loading ficha", err);
                setError("Error al cargar la ficha.");
            } finally {
                setLoading(false);
            }
        };
        if (user) loadFicha();
    }, [user]);

    const handleSave = async () => {
        setError(null);
        setSuccessMsg(null);
        try {
            const patientId = user.email;
            await updateFicha(patientId, fichaData);
            setSuccessMsg("Ficha guardada correctamente.");
            setTimeout(() => setSuccessMsg(null), 3000);
        } catch (err) {
            console.error(err);
            setError("Error al guardar la ficha: " + err.message);
        }
    };

    const updateSectionData = (section, field, value) => {
        setFichaData(prev => ({
            ...prev,
            [section]: {
                ...prev[section],
                [field]: value
            }
        }));
    };

    const updateListItem = (section, index, field, value) => {
        setFichaData(prev => {
            const newList = [...(prev[section] || [])];
            newList[index] = { ...newList[index], [field]: value };
            return { ...prev, [section]: newList };
        });
    };

    const addNewItem = (section, emptyTemplate = {}) => {
        setFichaData(prev => ({
            ...prev,
            [section]: [{ ...emptyTemplate, fecha: new Date().toISOString() }, ...(prev[section] || [])]
        }));
    };

    if (!user) return null;

    if (isProjectionMode) {
        const formatDate = (dateStr) => dateStr ? new Date(dateStr).toLocaleDateString('es-MX', { day: '2-digit', month: 'short', year: 'numeric' }).toUpperCase() : 'N/A';
        const data = fichaData;
        const latestEtapa = (data.etapa_clinica && data.etapa_clinica.length > 0) ? data.etapa_clinica[0] : {};
        const latestRiesgo = (data.riesgos && data.riesgos.length > 0) ? data.riesgos[0] : {};
        const latestAtencion = (data.atencion_integral && data.atencion_integral.length > 0) ? data.atencion_integral[0] : {};
        const latestComite = (data.comite_tumores && data.comite_tumores.length > 0)
            ? [...data.comite_tumores].sort((a, b) => new Date(b.fecha_presentacion) - new Date(a.fecha_presentacion))[0]
            : {};
        const resumen = data.resumen_clinico || {};

        // Helper calculations
        const calculateIMC = () => {
            if (data.demograficos?.peso && data.demograficos?.talla) {
                return (data.demograficos.peso / (data.demograficos.talla ** 2)).toFixed(1);
            }
            return 'N/A';
        };

        // Aggregated Timeline Events
        const getAllEvents = () => {
            let events = [];
            // Chemo (Sistémico)
            data.tratamientos_neoadyuvantes?.forEach(t => events.push({
                date: t.fecha_inicio,
                type: 'T. NEO',
                desc: `${t.medicamento || t.esquema || 'Esquema'} (${t.ciclos || '?'} ciclos). Resp: ${t.respuesta_clinica || '-'}`,
                class: 'chemo'
            }));
            data.tratamientos_adyuvantes?.forEach(t => events.push({
                date: t.fecha_inicio,
                type: 'T. ADY',
                desc: `${t.medicamento || t.esquema || 'Esquema'} (${t.ciclos || '?'} ciclos).`,
                class: 'chemo'
            }));

            // Surgery
            data.cirugia?.forEach(c => events.push({
                date: c.fecha,
                type: 'CIRUGÍA',
                desc: `${c.tipo_procedimiento}. ${c.hallazgos_quirurgicos ? `Hallazgos: ${c.hallazgos_quirurgicos}` : ''}`,
                class: 'surgery'
            }));

            // Radio
            data.radioterapia?.forEach(r => events.push({
                date: r.fecha_inicio,
                type: 'RADIO',
                desc: `${r.area_tratada} (${r.dosis_total} Gy en ${r.num_fracciones} fx). Intención: ${r.intencion_tratamiento}`,
                class: 'radio'
            }));

            // Committee
            data.comite_tumores?.forEach(c => events.push({
                date: c.fecha_presentacion,
                type: 'COMITÉ',
                desc: `${c.decision}. (Obj: ${c.objetivo})`,
                class: 'consult'
            }));

            // Imaging (Seguimientos)
            data.hallazgos?.forEach(h => events.push({
                date: h.fecha_estudio,
                type: 'IMAGEN',
                desc: `${h.tipo_estudio} - BIRADS ${h.birads}. ${h.conducta ? `Plan: ${h.conducta}` : 'Sin plan'}`,
                class: 'imaging'
            }));

            // Stage Evolution
            data.etapa_clinica?.forEach((e, i) => {
                if (i > 0) {
                    events.push({
                        date: e.fecha,
                        type: 'ETAPA',
                        desc: `T${e.cT}N${e.cN}M${e.cM} (${e.etapa})`,
                        class: 'stage'
                    });
                }
            });

            return events.sort((a, b) => new Date(a.date) - new Date(b.date));
        };

        const timelineEvents = getAllEvents();
        const GENERIC_PHOTO = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23e482ad' width='100px' height='100px'%3E%3Cpath d='M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z'/%3E%3C/svg%3E";

        return (
            <div className="projection-container">
                <button
                    onClick={() => setIsProjectionMode(false)}
                    style={{
                        position: 'fixed',
                        top: '20px',
                        right: '20px',
                        padding: '10px 20px',
                        backgroundColor: '#e91e63',
                        color: 'white',
                        border: 'none',
                        borderRadius: '8px',
                        cursor: 'pointer',
                        zIndex: 10000,
                        fontWeight: 'bold',
                        boxShadow: '0 4px 12px rgba(233, 30, 99, 0.4)'
                    }}
                >
                    Salir (ESC)
                </button>

                <div className="projection-header">
                    <div className="projection-title">
                        <h1>FICHA ONCOLÓGICA INTEGRAL</h1>
                        <div className="projection-subtitle">Centro de Decisiones Oncológicas • {new Date().toLocaleDateString('es-MX', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}</div>
                        {latestComite.nota && (
                            <div style={{ marginTop: '5px', background: '#fff1f2', padding: '8px 12px', borderRadius: '6px', borderLeft: '4px solid #be123c', color: '#881337', fontSize: '0.9em', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <div>
                                    <strong>Sesión Comité ({formatDate(latestComite.fecha_presentacion)}):</strong> {latestComite.nota}
                                </div>
                                <div style={{ fontSize: '0.85em', opacity: 0.8, textAlign: 'right' }}>
                                    <div>Obj: {latestComite.objetivo || 'N/A'}</div>
                                    <div>Presenta: {latestComite.presentado_por || 'N/A'}</div>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="patient-info-header">
                        <div style={{ textAlign: 'right' }}>
                            <div style={{ fontSize: '2em', fontWeight: 'bold', color: '#1e293b' }}>
                                {user.first_name} {user.last_name}
                            </div>
                            <div style={{ color: '#64748b' }}>
                                {data.demograficos?.edad || '?'} años • Expediente: {user.email?.split('@')[0]}
                            </div>
                            <div style={{ fontSize: '0.9em', fontWeight: 'bold', color: user.step === '5' ? '#059669' : '#e11d48' }}>
                                {data.demograficos?.estatus || 'ESTATUS NO DEFINIDO'}
                            </div>
                        </div>
                        <img
                            src={user.photo || GENERIC_PHOTO}
                            onError={(e) => { e.target.onerror = null; e.target.src = GENERIC_PHOTO; }}
                            className="patient-photo-projection"
                            alt="Paciente"
                        />
                    </div>
                </div>

                <div className="projection-grid">
                    {/* ROW 1: CLINICAL CONTEXT */}
                    <div className="projection-card card-pink" style={{ gridRow: 'span 2' }}>
                        <h3 className="card-title">Datos Generales & Clínicos</h3>
                        <div className="stats-grid">
                            <div className="stat-item">
                                <div className="stat-label">IMC</div>
                                <div className="stat-value">{calculateIMC()}</div>
                            </div>
                            <div className="stat-item">
                                <div className="stat-label">Sexo</div>
                                <div className="stat-value">{data.demograficos?.sexo || 'N/A'}</div>
                            </div>
                        </div>

                        <div style={{ marginTop: '15px', fontSize: '0.85em' }}>
                            <div className="stat-label">Referencia</div>
                            <div>{data.demograficos?.unidad_referencia || 'N/A'}</div>
                            <div style={{ fontSize: '0.8em', color: '#64748b' }}>{formatDate(data.demograficos?.fecha_referencia)}</div>
                        </div>

                        <div style={{ marginTop: '10px', fontSize: '0.85em' }}>
                            <div className="stat-label">Ingreso Hospital</div>
                            <div>{formatDate(data.demograficos?.fecha_ingreso_hospital)}</div>
                        </div>

                        <div style={{ marginTop: '10px' }}>
                            <div className="stat-label">Motivo Consulta</div>
                            <div style={{ fontWeight: '500', fontSize: '0.9em' }}>{data.demograficos?.motivo_consulta || 'N/A'}</div>
                        </div>

                        <div style={{ marginTop: '10px' }}>
                            <div className="stat-label">Síntoma Inicial</div>
                            <div style={{ fontSize: '0.9em' }}>{data.demograficos?.sintoma_inicial || 'N/A'}</div>
                            <div style={{ fontSize: '0.8em', color: '#64748b' }}>{formatDate(data.demograficos?.fecha_sintoma_inicial)}</div>
                        </div>

                        <div style={{ marginTop: '10px' }}>
                            <div className="stat-label">Tamizaje</div>
                            <div style={{ fontSize: '0.9em' }}>{data.demograficos?.tamizaje === 'SÍ' ? `SÍ (${formatDate(data.demograficos?.fecha_tamizaje)})` : 'NO'}</div>
                        </div>

                        <div style={{ marginTop: '15px', borderTop: '1px solid #fecdd3', paddingTop: '10px' }}>
                            <div className="stat-label">Comorbilidades</div>
                            <div style={{ fontSize: '0.85em', color: '#475569' }}>{data.demograficos?.comorbilidades || 'Niega crónico-degenerativos'}</div>
                        </div>

                        <div style={{ marginTop: '10px' }}>
                            <div className="stat-label">Tratamiento Previo (Externo)</div>
                            <div style={{ fontSize: '0.85em', color: '#b91c1c' }}>{data.demograficos?.tratamiento_fuera_issste || 'Ninguno'}</div>
                        </div>
                    </div>

                    <div className="projection-card card-purple">
                        <h3 className="card-title">Factores de Riesgo</h3>
                        <div className="tags-container">
                            {(data.demograficos?.factores_riesgo || []).map((f, i) => (
                                <span key={i} className="tag-badge tag-pos">{f}</span>
                            ))}
                            {latestRiesgo.antecedentes_heredofamiliares && <span className="tag-badge tag-pos">AHF CaMama</span>}
                            {!data.demograficos?.factores_riesgo?.length && !latestRiesgo.antecedentes_heredofamiliares && <span className="tag-badge tag-neu">Sin factores relevantes</span>}
                        </div>
                        <div style={{ marginTop: '15px' }}>
                            <div className="stat-label">Riesgo Calculado</div>
                            <div style={{ fontSize: '1.4em', fontWeight: 'bold', color: '#7c3aed' }}>{latestRiesgo.riesgo_identificado || 'No Evaluado'}</div>
                        </div>
                    </div>

                    <div className="projection-card card-red">
                        <h3 className="card-title">Etapa Clínica Actual</h3>
                        <div style={{ textAlign: 'center', padding: '10px' }}>
                            <div style={{ fontSize: '4em', fontWeight: '900', color: '#be123c', lineHeight: '1' }}>
                                {latestEtapa.etapa || 'X'}
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'center', gap: '15px', marginTop: '10px' }}>
                                <span className="tag-badge tag-neu">T: {latestEtapa.cT || 'x'}</span>
                                <span className="tag-badge tag-neu">N: {latestEtapa.cN || 'x'}</span>
                                <span className="tag-badge tag-neu">M: {latestEtapa.cM || 'x'}</span>
                            </div>
                            <div style={{ marginTop: '10px', fontSize: '0.8em', color: '#64748b' }}>
                                {latestEtapa.fecha ? `Actualizado: ${formatDate(latestEtapa.fecha)}` : 'Sin estadificación'}
                            </div>
                        </div>
                    </div>

                    <div className="projection-card card-green">
                        <h3 className="card-title">Atención Integral</h3>
                        <div className="stats-grid">
                            <div className="stat-item">
                                <div className="stat-label">ECOG</div>
                                <div className="stat-value" style={{ color: '#059669' }}>{latestAtencion.estado_funcional || '0'}</div>
                            </div>
                            <div className="stat-item">
                                <div className="stat-label">Red Apoyo</div>
                                <div className="stat-value">{latestAtencion.paciente_red_apoyo ? 'SÍ' : 'NO'}</div>
                            </div>
                        </div>
                        <div style={{ marginTop: '15px' }}>
                            <div className="stat-label">Interconsultas</div>
                            <div className="tags-container">
                                {latestAtencion.psicologia?.length > 0 && <span className="tag-badge tag-blue">Psico ({latestAtencion.psicologia.length})</span>}
                                {latestAtencion.nutricion?.length > 0 && <span className="tag-badge tag-green">Nutri ({latestAtencion.nutricion.length})</span>}
                                {latestAtencion.cuidados_paliativos?.length > 0 && <span className="tag-badge tag-purple">Paliativos</span>}
                            </div>
                        </div>
                    </div>

                    {/* ROW 2: IMAGING & PATHOLOGY */}
                    <div className="projection-card card-blue" style={{ gridColumn: 'span 1' }}>
                        <h3 className="card-title">Imagenología (Resumen)</h3>
                        <div style={{ display: 'flex', gap: '10px', height: '140px', marginBottom: '15px' }}>
                            {data.esquema_mamario_url ?
                                <img src={data.esquema_mamario_url} style={{ width: '48%', objectFit: 'cover', borderRadius: '8px', border: '1px solid #e2e8f0' }} /> :
                                <div style={{ width: '48%', background: '#f1f5f9', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.8em', color: '#94a3b8' }}>Sin Mamografía</div>}
                            {data.esquema_axilar_url ?
                                <img src={data.esquema_axilar_url} style={{ width: '48%', objectFit: 'cover', borderRadius: '8px', border: '1px solid #e2e8f0' }} /> :
                                <div style={{ width: '48%', background: '#f1f5f9', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.8em', color: '#94a3b8' }}>Sin USG Axilar</div>}
                        </div>
                        <div>
                            <div className="stat-label">Historial de Imagen (Últimos 3)</div>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginTop: '5px' }}>
                                {data.hallazgos?.slice(0, 3).map((h, i) => (
                                    <div key={i} style={{ borderBottom: '1px solid #e2e8f0', paddingBottom: '5px' }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.85em', fontWeight: 'bold' }}>
                                            <span>{h.tipo_estudio}</span>
                                            <span>{formatDate(h.fecha_estudio)}</span>
                                        </div>
                                        <div style={{ fontSize: '0.8em', color: '#be123c' }}>BIRADS: {h.birads}</div>
                                        <div style={{ fontSize: '0.75em', color: '#64748b' }}>{h.descripcion_hallazgo}</div>
                                    </div>
                                ))}
                                {!data.hallazgos?.length && <div style={{ fontSize: '0.8em', color: '#94a3b8' }}>Sin estudios registrados</div>}
                            </div>
                        </div>
                    </div>

                    <div className="projection-card card-orange" style={{ gridColumn: 'span 3' }}>
                        <h3 className="card-title">
                            <span>Patología e Inmunohistoquímica</span>
                            <span style={{ fontSize: '0.8em', fontWeight: 'normal' }}>{data.patologia?.length || 0} reportes registrados</span>
                        </h3>
                        <div style={{ overflowX: 'auto' }}>
                            <table className="dense-table">
                                <thead>
                                    <tr>
                                        <th>Fecha</th>
                                        <th>Tipo</th>
                                        <th>Diagnóstico</th>
                                        <th>Tamaño</th>
                                        <th>RE</th>
                                        <th>RP</th>
                                        <th>HER2</th>
                                        <th>Ki67</th>
                                        <th>Estudios</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.patologia?.map((p, i) => (
                                        <tr key={i}>
                                            <td style={{ whiteSpace: 'nowrap' }}>{formatDate(p.fecha_procedimiento)}</td>
                                            <td>{p.tipo_procedimiento}</td>
                                            <td style={{ maxWidth: '180px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} title={p.diagnostico}>{p.diagnostico}</td>
                                            <td>{p.tamano || '-'}</td>
                                            <td><span className={`tag-badge ${p.biomarcadores?.RE?.includes('Pos') ? 'tag-pos' : 'tag-neu'}`}>{p.biomarcadores?.RE || '-'}</span></td>
                                            <td><span className={`tag-badge ${p.biomarcadores?.RP?.includes('Pos') ? 'tag-pos' : 'tag-neu'}`}>{p.biomarcadores?.RP || '-'}</span></td>
                                            <td><span className={`tag-badge ${p.biomarcadores?.HER2?.includes('Pos') || p.biomarcadores?.HER2?.includes('3+') ? 'tag-red' : 'tag-neu'}`}>{p.biomarcadores?.HER2 || '-'}</span></td>
                                            <td>{p.biomarcadores?.Ki67 || '-'}</td>
                                            <td style={{ fontSize: '0.8em' }}>{p.estudios_adicionales || '-'}</td>
                                        </tr>
                                    ))}
                                    {!data.patologia?.length && <tr><td colSpan="9" style={{ textAlign: 'center', padding: '20px' }}>No hay registros de patología</td></tr>}
                                </tbody>
                            </table>
                            {/* Pathology Extras */}
                            <div style={{ marginTop: '10px', display: 'flex', gap: '15px', fontSize: '0.85em', borderTop: '1px solid #fed7aa', paddingTop: '8px' }}>
                                <div><strong>Viraje Molecular:</strong> {data.datos_adicionales_patologia?.[0]?.viraje || 'No reportado'}</div>
                                <div><strong>Decisión Patológica:</strong> {data.datos_adicionales_patologia?.[0]?.decision || 'N/A'}</div>
                                <div><strong>Ganglios +/Totales:</strong> {data.datos_adicionales_patologia?.[0]?.ganglios_positivos || '?'}/{data.datos_adicionales_patologia?.[0]?.ganglios_totales || '?'}</div>
                            </div>
                        </div>
                    </div>

                    {/* ROW 3: TIMELINE */}
                    <div className="projection-card card-blue" style={{ gridColumn: 'span 4' }}>
                        <h3 className="card-title">Línea de Tiempo Clínica</h3>
                        <div className="timeline-track">
                            {!timelineEvents.length && <div style={{ padding: '20px', color: '#94a3b8' }}>No hay eventos registrados en la línea de tiempo.</div>}
                            {timelineEvents.map((ev, i) => (
                                <div key={i} className={`timeline-event-card ${ev.class}`}>
                                    <div style={{ fontSize: '0.8em', fontWeight: 'bold', color: '#64748b' }}>{formatDate(ev.date)}</div>
                                    <div style={{ fontWeight: 'bold', color: '#334155', margin: '5px 0' }}>{ev.type}</div>
                                    <div style={{ fontSize: '0.85em', lineHeight: '1.4' }}>{ev.desc}</div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* ROW 4: CLINICAL SUMMARY FOOTER */}
                    <div className="projection-card" style={{ gridColumn: 'span 4', background: '#1e293b', color: 'white', display: 'flex', justifyContent: 'space-around', alignItems: 'center', padding: '15px', marginTop: '10px' }}>
                        <div style={{ textAlign: 'center' }}>
                            <div style={{ fontSize: '0.7em', opacity: 0.8, textTransform: 'uppercase', letterSpacing: '1px' }}>RESUMEN CLÍNICO</div>
                            <div style={{ fontSize: '1.2em', fontWeight: 'bold' }}>Etapa Patológica: {resumen.etapa_patologica || 'N/R'}</div>
                        </div>
                        <div style={{ height: '40px', width: '1px', background: '#475569' }}></div>
                        <div style={{ textAlign: 'center' }}>
                            <div style={{ fontSize: '0.7em', opacity: 0.8 }}>Supervivencia Libre Enf. (SLE)</div>
                            <div style={{ fontSize: '1.5em', fontWeight: 'bold', color: '#4ade80' }}>{resumen.sle || 'N/R'}</div>
                        </div>
                        <div style={{ height: '40px', width: '1px', background: '#475569' }}></div>
                        <div style={{ textAlign: 'center' }}>
                            <div style={{ fontSize: '0.7em', opacity: 0.8 }}>Supervivencia Global (SG)</div>
                            <div style={{ fontSize: '1.5em', fontWeight: 'bold', color: '#4ade80' }}>{resumen.sg || 'N/R'}</div>
                        </div>
                        <div style={{ height: '40px', width: '1px', background: '#475569' }}></div>
                        <div style={{ textAlign: 'center' }}>
                            <div style={{ fontSize: '0.7em', opacity: 0.8 }}>Resumen Tratamiento (TTO)</div>
                            <div style={{ fontSize: '1em', maxWidth: '350px', lineHeight: '1.2' }}>{resumen.tto || 'N/R'}</div>
                        </div>
                    </div>

                </div>
            </div>
        );
    }

    return (
        <div className="ficha-container">
            <div className="ficha-header">
                <h2>Ficha Oncológica: {user.first_name} {user.last_name}</h2>
                <div style={{ display: 'flex', gap: '10px' }}>
                    <button
                        className="btn-secondary"
                        style={{ backgroundColor: '#e67e22', color: 'white' }}
                        onClick={() => setIsProjectionMode(true)}
                    >
                        📺 Modo Proyección TV
                    </button>
                    <button className="close-btn" onClick={onClose}>×</button>
                </div>
            </div>

            <div className="ficha-tabs">
                {/* Standalone: Datos Generales */}
                <button
                    className={activeTab === 'demograficos' ? 'active' : ''}
                    onClick={() => setActiveTab('demograficos')}
                >
                    Datos Generales
                </button>

                {/* Dropdown: Diagnóstico */}
                <DropdownMenu
                    label="Diagnóstico"
                    items={[
                        { id: 'hallazgos', label: 'Hallazgos' },
                        { id: 'riesgos', label: 'Riesgos' },
                        { id: 'etapa', label: 'Etapa Clínica' },
                        { id: 'patologia', label: 'Patología' },
                        { id: 'patologia_adicional', label: 'Patología Detallada' },
                        { id: 'cirugia', label: 'Cirugía' },
                        { id: 'comite_tumores', label: 'Comité Tumores' }
                    ]}
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                />

                {/* Dropdown: Tratamiento */}
                <DropdownMenu
                    label="Tratamiento"
                    items={[
                        { id: 'tratamiento', label: 'Tratamiento Sistémico' },
                        { id: 'radioterapia', label: 'Radioterapia' },
                        { id: 'inmunoterapia', label: 'Inmunoterapia' },
                        { id: 'terapia_dirigida', label: 'Terapia Dirigida' }
                    ]}
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                />

                {/* Standalone: Atención Integral */}
                <button
                    className={activeTab === 'atencion_integral' ? 'active' : ''}
                    onClick={() => setActiveTab('atencion_integral')}
                >
                    Atención Integral
                </button>

                {/* Dropdown: Seguimiento */}
                <DropdownMenu
                    label="Seguimiento"
                    items={[
                        { id: 'seguimiento', label: 'Seguimiento' },
                        { id: 'recurrencias', label: 'Recurrencias' },
                        { id: 'estudios_imagen', label: 'Estudios de Imagen' },
                        { id: 'genetica', label: 'Genética' },
                        { id: 'reconstruccion', label: 'Reconstrucción Mamaria' }
                    ]}
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                />

                {/* Standalone: Anexos */}
                <button
                    className={activeTab === 'anexos' ? 'active' : ''}
                    onClick={() => setActiveTab('anexos')}
                >
                    Anexos
                </button>
            </div>

            <div className="ficha-content">
                {loading && <div className="loading">Cargando ficha...</div>}

                {!loading && activeTab === 'demograficos' && (
                    <DemograficosSection
                        data={fichaData.demograficos}
                        onChange={(field, val) => updateSectionData('demograficos', field, val)}
                        patientPhoto={user.photo}
                    />
                )}

                {!loading && activeTab === 'hallazgos' && (
                    <HallazgosSection
                        data={fichaData.hallazgos}
                        onAdd={addNewItem}
                        onUpdate={updateListItem}
                    />
                )}

                {!loading && activeTab === 'riesgos' && (
                    <RiesgosSection
                        data={fichaData.riesgos}
                        onAdd={addNewItem}
                        onUpdate={updateListItem}
                    />
                )}

                {!loading && activeTab === 'atencion_integral' && (
                    <AtencionIntegralSection
                        data={fichaData.atencion_integral}
                        onAdd={addNewItem}
                        onUpdate={updateListItem}
                    />
                )}

                {!loading && activeTab === 'etapa' && (
                    <EtapaSection
                        data={fichaData.etapa_clinica}
                        onAdd={addNewItem}
                        onUpdate={updateListItem}
                    />
                )}

                {!loading && activeTab === 'patologia' && (
                    <PatologiaSection
                        data={fichaData.patologia}
                        onAdd={addNewItem}
                        onUpdate={updateListItem}
                    />
                )}

                {!loading && activeTab === 'patologia_adicional' && (
                    <DatosAdicionalesPatologiaSection
                        data={fichaData.datos_adicionales_patologia}
                        onAdd={addNewItem}
                        onUpdate={updateListItem}
                    />
                )}

                {!loading && activeTab === 'cirugia' && (
                    <CirugiaSection
                        data={fichaData.cirugia}
                        onAdd={addNewItem}
                        onUpdate={updateListItem}
                    />
                )}

                {!loading && activeTab === 'comite_tumores' && (
                    <ComiteSection
                        data={fichaData.comite_tumores}
                        onAdd={addNewItem}
                        onUpdate={updateListItem}
                    />
                )}

                {!loading && activeTab === 'recurrencias' && (
                    <RecurrenciaSection
                        data={fichaData.recurrencias}
                        onAdd={addNewItem}
                        onUpdate={updateListItem}
                    />
                )}

                {!loading && activeTab === 'tratamiento' && (
                    <TratamientoSection
                        neoadyuvantes={fichaData.tratamientos_neoadyuvantes}
                        adyuvantes={fichaData.tratamientos_adyuvantes}
                        paliativos={fichaData.tratamientos_paliativos}
                        onAdd={addNewItem}
                        onUpdate={updateListItem}
                    />
                )}

                {!loading && activeTab === 'radioterapia' && (
                    <RadioterapiaSection
                        data={fichaData.radioterapia}
                        onAdd={addNewItem}
                        onUpdate={updateListItem}
                    />
                )}

                {!loading && activeTab === 'inmunoterapia' && (
                    <InmunoterapiaSection
                        data={fichaData.inmunoterapia}
                        onAdd={addNewItem}
                        onUpdate={updateListItem}
                    />
                )}

                {!loading && activeTab === 'terapia_dirigida' && (
                    <TerapiaDirigidaSection
                        data={fichaData.terapia_dirigida}
                        onAdd={addNewItem}
                        onUpdate={updateListItem}
                    />
                )}

                {!loading && activeTab === 'estudios_imagen' && (
                    <EstudiosImagenSection
                        data={fichaData.estudios_imagen}
                        onAdd={addNewItem}
                        onUpdate={updateListItem}
                    />
                )}

                {!loading && activeTab === 'genetica' && (
                    <GeneticaSection
                        data={fichaData.genetica}
                        onAdd={addNewItem}
                        onUpdate={updateListItem}
                    />
                )}

                {!loading && activeTab === 'reconstruccion' && (
                    <ReconstruccionSection
                        data={fichaData.reconstruccion_mamaria}
                        onAdd={addNewItem}
                        onUpdate={updateListItem}
                    />
                )}

                {!loading && activeTab === 'seguimiento' && (
                    <SeguimientoSection
                        data={fichaData.seguimientos}
                        onAdd={addNewItem}
                        onUpdate={updateListItem}
                    />
                )}

                {!loading && activeTab === 'anexos' && (
                    <AnexosSection
                        data={fichaData.anexos}
                        esquemas={{ mamario: fichaData.esquema_mamario_url, axilar: fichaData.esquema_axilar_url }}
                    />
                )}



            </div>



            <div className="ficha-actions">
                {error && <div className="error-msg">{error}</div>}
                {successMsg && <div className="success-msg">{successMsg}</div>}
                <Button onClick={handleSave}>Guardar Ficha</Button>
            </div>
        </div>
    );
};

export default FichaContainer;
